import "../../styles/svg/index.css";

const svg: Function = () => ({
  FormalModelPC: [
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 150 150">
      <path
        className="modelFormalPc0 baseAnimation"
        d="M33.16,130.34c-0.83,1.77-3.88,7.62-10.44,8.44c-1.88,0.24-3.63,0.01-5.09-0.36
        c-2.73-5.06-0.83-11.15,3.67-13.12C25.45,123.49,30.81,125.61,33.16,130.34z"
      />
      <path
        className="modelFormalPc1 baseAnimation"
        d="M31.66,129.75c-0.8,1.55-3.71,6.65-9.62,7.54c-1.69,0.26-3.26,0.11-4.56-0.16c-2.31-4.27-0.43-9.54,3.67-11.36
        C24.93,124.09,29.68,125.76,31.66,129.75z"
      />
      <path
        className="modelFormalPc2 baseAnimation"
        d="M34.01,123.48l-6.85,11.87c-0.23,0.11-4.08,1.83-7.54-0.45c-2.58-1.7-3.14-4.44-3.24-4.98
        c1.92-4.43,3.84-8.87,5.76-13.3L34.01,123.48z"
      />
      <path
        className="modelFormalPc3"
        d="M33.83,127.47c-1.47-1.9-2.95-2.98-4.03-3.61c-2.23-1.3-3.81-1.33-7.5-3c-1.26-0.57-2.25-1.1-2.9-1.46
        c1.04-1.47,2.08-2.95,3.12-4.42c1.52,0.08,4.05,0.4,6.91,1.69c3.81,1.71,6.12,4.19,7.15,5.44C35.66,123.9,34.75,125.69,33.83,127.47
        z"
      />
      <path
        className="modelFormalPc4"
        d="M127,110.82c-7.1,14.88-14.72,19.16-20.16,20.44c-20.64,4.85-42.31-26.89-56.11-19.29
        c-6.28,3.46-8.35,13.59-14.03,12.9c-1.18-0.14-3.6-1.47-8.45-4.13c-2.72-1.49-4.37-2.55-6.71-2.32c-1.48,0.14-2.65,0.75-3.05,0.23
        c-0.26-0.33-0.11-0.98,1.26-3.37c0.91-1.59,1.37-2.39,2.48-3.95c0.93-1.3,2.2-3.25,3.56-5.86l0,0c3.26-6.09,8.21-19.37,14.99-40.41
        c1.28-0.74,13.78-7.99,15.09-8.75c0.9-0.52,11.72-6.8,12.64-7.33c7.76,0.45,15.53,0.9,23.29,1.35c3.87,2.88,7.88,5.79,12.04,8.7
        c4.7,3.29,9.34,6.4,13.88,9.35C120.8,82.53,123.9,96.67,127,110.82z"
      />
      <path
        className="modelFormalPc5"
        d="M91.18,50.32c-1.11,5.74-5.08,10.01-9.73,10.63c-5.48,0.73-10.93-3.75-12.34-10.63c0-6.06,0-12.11,0-18.17
        h22.07V50.32z"
      />
      <path
        className="modelFormalPc2"
        d="M96.89,23.13c-4.26-8.57-22.65-10.9-29.01-2.93c-3.78,4.74-2.22,11.77-1.35,15.69
        c0.89,4.02,2.43,10.98,8.69,14.11c3.69,1.85,8.89,2.28,13.02-0.15c3.71-2.19,4.97-5.77,6.73-10.79
        C97.23,32.62,99.04,27.45,96.89,23.13z"
      />
      <path
        className="modelFormalPc6"
        d="M96.46,34.66c0.24-1.4,0.46-3.45,0.2-5.88c-0.27-2.61-0.62-5.91-2.6-7c-1.79-0.98-3.12,0.83-6.66,1.47
        c-6.93,1.24-10.09-4.26-15.57-2.14c-0.51,0.2-2.94,1.13-4.29,3.5c-0.76,1.32-0.94,2.68-1.24,4.85c-0.23,1.65-0.28,3.04-0.28,4.03
        C64.2,25.92,63.95,22.56,64.2,21c0.05-0.35,0.54-3.81,0.64-4.82c0.09-0.99,0.06-1.06,0.27-1.77c0.43-1.46,1.71-4.93,5.89-7.97
        c2.5-1.56,4.7-2.43,6.29-2.97c2.23-0.77,5.23-1.51,8.76-1.26l0,0c3.04,0.15,4.91,1.59,5.34,1.94c0.78,0.63,1.37,1.11,1.5,1.93
        c0.11,0.67-0.16,1.2,0.11,1.49c0.3,0.33,0.89-0.06,1.34-0.12c1.81-0.28,3.87,4.12,4.86,6.99c0.72,2.11,1.41,4.09,1.32,6.8
        c-0.03,0.8-0.14,2.13-2.03,7.79C97.69,31.35,96.98,33.29,96.46,34.66z"
      />
      <path
        className="modelFormalPc7"
        d="M97.32,30.46c-0.16-5.79-1.76-7.88-3.25-8.68c-2.78-1.51-5.2,1.44-10.19,0.42c-4.3-0.88-4.52-3.47-8.12-3.5
        c-3.32-0.02-6.4,2.16-8.12,4.62c-1.65,2.36-1.91,4.78-1.96,5.88c-0.64-2.25-1.89-7.84,0.28-14.28c1.37-4.06,3.56-6.88,5.04-8.49
        c9.49-4.95,17.44-5.13,19.46-2.01c1.94,2.99-1.76,8.73-2.61,10c1.09-2.36,3.62-7.15,6.48-6.99c3.57,0.2,6.59,8.07,5.97,14.65
        C99.94,25.84,98.43,28.73,97.32,30.46z"
      />
      <path className="modelFormalPc2" d="M0.09,118.66" />
      <path
        className="modelFormalPc3"
        d="M80.52,94.62c-6.8-23.02-11.62-39.86-12.2-42.17c-0.07-0.27-0.48-2,0.05-3.99c0.2-0.74,0.35-1.31,0.73-1.42
        c0.89-0.26,1.81,2.25,4.55,5.41c1.4,1.62,1.14,0.93,4.37,4.2c2.27,2.29,2.7,2.93,3.57,2.89c0.9-0.04,1.17-0.77,3.94-3.57
        c1.59-1.61,1.58-1.45,2.37-2.32c0.9-1,2.13-2.56,3.27-4.82c0.13,0.22,0.34,0.6,0.51,1.11c0.71,2.09,0,4.07-0.22,4.72
        c-3.17,9.16-5.32,18.64-8.08,27.93C82.58,85.29,81.46,89.42,80.52,94.62z"
      />
      <g>
        <path
          className="modelFormalPc8 baseAnimation"
          d="M128.58,59.88c21.2,31.18,6.99,65.33,0.67,76.63c-3.06,5.49-5.27,7.39-7.41,8.61
            c-13.89,7.92-29.27-10.52-54.69-7.94c-17.65,1.79-24.98,12.17-34.93,7.67c-5.45-2.46-8.08-7.76-10.27-14.68
            c-5.56-17.61-15.4-48.74,6.71-75.43c3.89-4.7,23.08-27.87,52.14-26.19C108.37,30.16,123.82,52.88,128.58,59.88z"
        />
        <path
          className="modelFormalPc9 baseAnimation"
          d="M128.46,81.95c21.2,23.31,6.99,48.82,0.67,57.27c-3.06,4.1-5.27,5.52-7.41,6.44
            c-13.89,5.92-29.27-7.86-54.69-5.94c-17.65,1.34-24.98,9.1-34.93,5.73c-5.45-1.84-8.08-5.8-10.27-10.97
            c-5.56-13.16-15.4-36.43,6.71-56.37c3.89-3.51,23.08-20.83,52.14-19.57C108.25,59.73,123.7,76.72,128.46,81.95z"
        />
      </g>
      <path
        className="modelFormalPc10"
        d="M80.82,59.32c-2.89,1.96-5.77,3.92-8.66,5.87c-0.8-3.79-1.69-6.74-2.38-8.77c-1.1-3.25-2.32-6.13-0.96-8.54
        c0.21-0.37,0.44-0.65,0.59-0.82C73.22,51.14,77.02,55.23,80.82,59.32z"
      />
      <path
        className="modelFormalPc11"
        d="M83.03,83.8c-0.13,1.18-1.05,9.4-2.61,9.45c-1.62,0.05-3.04-8.79-3.21-9.84c-0.19-2.73-0.2-6.1,0.32-9.9
        c0.4-2.96,1.04-5.55,1.72-7.73c0.69,0.03,1.37,0.06,2.06,0.09c0.13,2.62,0.31,5.33,0.57,8.13C82.19,77.41,82.58,80.68,83.03,83.8z"
      />
      <path
        className="modelFormalPc10"
        d="M80.44,59.33c1.58-0.83,3.6-2.09,5.64-3.99c2.53-2.35,4.12-4.77,5.1-6.53c0.3,0.67,0.71,1.78,0.82,3.19
        c0.22,2.82-0.95,4.59-2.6,9.12c-0.41,1.12-1,2.82-1.62,4.97C85.33,63.84,82.89,61.59,80.44,59.33z"
      />
      <path
        className="modelFormalPc11"
        d="M84.72,63.32c-1.58,1.32-3.17,2.64-4.75,3.96c-1.19-1.65-2.39-3.31-3.58-4.96c1.45-0.91,2.9-1.82,4.34-2.73
        C82.06,60.83,83.39,62.08,84.72,63.32z"
      />
      <path
        className="modelFormalPc12"
        d="M79.4,102.42c4.06-9.59,8.95-19.7,14.84-30.1c1.98-3.49,3.97-6.85,5.99-10.09c-1.35-0.7-2.71-1.4-4.06-2.1
        c1.2-0.7,2.39-1.4,3.59-2.1c-2.66-2.91-5.32-5.83-7.97-8.74c-0.22,1.64-0.59,3.9-1.27,6.57c-0.33,1.31-0.64,2.27-0.81,2.89
        c-0.94,3.35-3.69,9.87-3.91,10.39c0,0-0.01,0.02-0.01,0.03C83.86,73.71,81.71,83.58,79.4,102.42z"
      />
      <path
        className="modelFormalPc12"
        d="M81.5,99.48c-4.22-9.15-8.95-18.61-14.28-28.28c-2.08-3.79-4.19-7.47-6.3-11.06c1.21-0.7,2.43-1.4,3.64-2.1
        c-1.07-0.7-2.15-1.4-3.22-2.1c2.43-2.77,4.87-5.55,7.3-8.32c-0.14,0.74-0.25,1.83,0,3.09c0.14,0.71,0.33,1.14,0.57,1.79
        c0.66,1.79,0.84,2.93,1.15,4.16c0.85,3.38,3.52,10.41,3.52,10.41C75.25,70.48,77.52,78.84,81.5,99.48z"
      />
      <path
        className="modelFormalPc0"
        d="M33.76,147.41h86.76c1.01-18.47,2.03-36.93,3.04-55.4c-31.23-0.19-62.45-0.38-93.68-0.57
        C31.17,110.09,32.46,128.75,33.76,147.41z"
      />
      <path
        className="modelFormalPc13"
        d="M35.46,147.41h83.31c0.97-17.73,1.95-35.47,2.92-53.2c-29.99-0.18-59.97-0.36-89.96-0.55
        C32.98,111.57,34.22,129.49,35.46,147.41z"
      />
    </svg>,
  ],
  ico: {
    icoDescription: [
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 28.3 28.3">
        <path
          className="icoDescription0"
          d="M24.8,27.3H4.1V1h20.8c0,4,0,8,0,12C24.8,17.8,24.8,22.6,24.8,27.3z"
        />
        <rect
          x="6.5"
          y="8.9"
          className="icoDescription1"
          width="14.8"
          height="1.5"
        />
        <rect
          x="6.7"
          y="11.4"
          className="icoDescription1"
          width="14.8"
          height="0.8"
        />
        <rect
          x="6.7"
          y="13.1"
          className="icoDescription1"
          width="14.8"
          height="0.8"
        />
        <rect
          x="6.7"
          y="14.3"
          className="icoDescription1"
          width="14.8"
          height="0.8"
        />
        <rect
          x="6.7"
          y="16.2"
          className="icoDescription1"
          width="14.8"
          height="0.8"
        />
        <rect
          x="6.7"
          y="17.6"
          transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 19.4863 35.9092)"
          className="icoDescription1"
          width="6.2"
          height="0.8"
        />
        <rect
          x="6.7"
          y="19.4"
          transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 19.4863 39.5337)"
          className="icoDescription1"
          width="6.2"
          height="0.8"
        />
        <rect
          x="6.7"
          y="20.7"
          transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 19.4863 42.1254)"
          className="icoDescription1"
          width="6.2"
          height="0.8"
        />
        <rect
          x="6.7"
          y="22"
          transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 19.4863 44.717)"
          className="icoDescription1"
          width="6.2"
          height="0.8"
        />
        <rect
          x="6.7"
          y="23.3"
          transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 19.4863 47.3086)"
          className="icoDescription1"
          width="6.2"
          height="0.8"
        />
        <rect
          x="13.8"
          y="17.6"
          className="icoDescription2"
          width="8.1"
          height="6.5"
        />
        <rect
          x="15.3"
          y="3.2"
          transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 36.7388 7.1422)"
          className="icoDescription1"
          width="6.2"
          height="0.8"
        />
        <circle className="icoDescription3" cx="17.9" cy="11.6" r="5.6" />
        <path
          className="icoDescription4"
          d="M3.3,22.5l-0.5-0.7L13,14.7c0,0,0.3,0,0.4,0.3c0.1,0.2,0.1,0.4,0.1,0.5C10.1,17.8,6.7,20.2,3.3,22.5z"
        />
        <circle className="icoDescription5" cx="17.9" cy="11.4" r="5.6" />
      </svg>,
    ],
    icoWorld: [
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 28.3 28.3">
        <circle className="icoWorld0" cx="14.2" cy="14.3" r="13.4" />
        <path
          className="icoWorld1"
          d="M10.8,20.6c0-0.4,0-1-0.3-1.7s-0.6-1.2-0.9-1.5c-0.3-2.4,0.1-3.6,0.6-4.2c0.1-0.2,0.5-0.6,0.4-1
	c-0.1-0.5-0.6-0.5-1-0.9c-1-1,0-2.9-0.7-3.3C8.6,7.7,8.2,8.3,7.4,8.2C6.5,8,5.6,6.9,5.6,5.9c0-0.8,0.7-1.4,1.9-2.4
	c0.4-0.4,1.2-1,2.4-1.5c0.9-0.4,1.7-0.5,3.2-0.7c1.4-0.2,2-0.3,2.5-0.1c0.1,0,2.2,0.6,2.7,2.5c0.4,1.5-0.4,2.7-0.8,3.4s-1,1.7-2,1.7
	C14.4,8.9,13.8,7.7,13,8c-0.6,0.2-0.6,0.9-1.2,1c-0.8,0.2-1.3-0.6-1.7-0.4c-0.2,0.1-0.3,0.5,0,1.9c0.3,0.6,1,1.6,2.2,2.2
	c0.5,0.2,0.9,0.3,1.3,0.3c2.1,0.3,2.9-0.6,4,0c0.2,0.1,1,0.5,1,1.1c0.1,0.7-0.7,1.1-1.6,2.5c-0.3,0.5-0.5,1-0.7,1.3
	c-1.1,0.6-1.4,1.1-1.4,1.5c0,0.3,0.1,0.6-0.1,0.9c-0.2,0.3-0.5,0.2-0.9,0.5c-0.2,0.2-0.2,0.4-0.4,0.6c-0.2,0.6-0.4,0.7-0.5,1
	c0,0.1,0,0.1,0,0.4c0,0.4-0.1,0.4-0.1,0.7c0,0.4,0.1,0.8,0.2,1c0.1,0.2,0.1,0.3,0.1,0.5s-0.1,0.3-0.1,0.5c0,0.3,0.2,0.4,0.1,0.5
	c-0.1,0.1-0.2,0.1-0.3,0c0.1,0,0.1-0.4,0.1-0.5c0-0.2,0-0.3,0-0.4c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.4
	c0-0.3,0-0.5-0.1-0.6c0-0.3-0.1-0.5-0.3-1c-0.2-0.4-0.3-0.7-0.5-1.1C11.5,21.5,11.2,21.1,10.8,20.6z"
        />
        <path
          className="icoWorld1"
          d="M24.6,17.4c-0.4,0.3-0.6,0.3-0.7,0.1c-0.2-0.2-0.1-0.7-0.3-1.3c-0.2-0.6-0.5-0.5-0.8-1
	c-0.3-0.7,0.1-1.6,0.5-3.5c0.1-0.8,0.2-1.4,0.2-1.8c0.2-0.3,0.6-0.7,1-0.7c0.5,0,0.7,0.4,1,0.3c0.2,0,0.4-0.2,0.7-1.2
	c0.2,0.4,0.4,0.8,0.6,1.4c0.2,0.5,0.6,1.8,0.7,3.5c0.2,3.5-1,6.4-1.2,6.3c-0.1,0,0-0.3-0.2-0.5c-0.2-0.1-0.4,0-0.5-0.1
	c-0.2-0.2-0.1-0.5-0.2-0.9C25.4,17.9,25.2,17.6,24.6,17.4z"
        />
        <path
          className="icoWorld1"
          d="M12.7,26c-0.1,0-0.2,0.1-0.2,0.1c0-0.1,0-0.1,0-0.2c0,0,0.1,0,0.2-0.1l0.1-0.1c0.1,0,0.2,0.1,0.1,0.2
	C12.8,26,12.7,26,12.7,26z"
        />
        <path
          className="icoWorld1"
          d="M12.8,26.3c-0.1,0.1-0.2,0-0.2,0c-0.1,0-0.2-0.1-0.2-0.1v-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.1,0v0.1
	C12.9,26.3,12.9,26.3,12.8,26.3z"
        />
        <path
          className="icoWorld1"
          d="M13.3,26.6c-0.1-0.1-0.1-0.1-0.1-0.2v-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.1,0c0,0.1,0,0.1-0.1,0.2
	C13.4,26.5,13.3,26.5,13.3,26.6z"
        />
        <path
          className="icoWorld1"
          d="M13.1,26.6C13.1,26.6,13,26.6,13.1,26.6c-0.1,0-0.1-0.1-0.1-0.1l0,0h0.1C13.1,26.5,13.1,26.5,13.1,26.6
	L13.1,26.6z"
        />
        <path
          className="icoWorld1"
          d="M12.6,25.6c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.1-0.1-0.1-0.2v-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.1,0v0.1
	C12.6,25.4,12.6,25.5,12.6,25.6z"
        />
        <path
          className="icoWorld1"
          d="M13.1,26.3C13,26.4,13,26.4,13.1,26.3C13,26.4,13,26.3,13.1,26.3C13,26.3,13,26.3,13.1,26.3c0-0.1,0-0.1,0-0.1
	C13.1,26.2,13.1,26.3,13.1,26.3L13.1,26.3z"
        />
      </svg>,
    ],
    icoHome: [
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 28.3 28.3">
        <rect
          x="2.4"
          y="14.6"
          className="icoHome0"
          width="23.6"
          height="11.5"
        />
        <path
          className="icoHome1"
          d="M25.3,27.1H2.1C2.1,27,2,26.8,2,26.5c0-0.2,0.1-0.4,0.1-0.5c7.7,0,15.5,0,23.2,0c0,0.1,0.1,0.3,0.1,0.6
C25.4,26.8,25.4,27,25.3,27.1z"
        />
        <path
          className="icoHome2"
          d="M25.3,27H2.1c0,0-0.1-0.1-0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c7.7,0,15.5,0,23.2,0c0,0,0.1,0.2,0.1,0.3
C25.4,26.8,25.4,26.9,25.3,27z"
        />
        <path
          className="icoHome3"
          d="M24.6,14.8H2.4c0,0-0.1-0.1-0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c7.4,0,14.8,0,22.2,0c0,0,0.1,0.2,0.1,0.3
C24.7,14.6,24.7,14.7,24.6,14.8z"
        />
        <path
          className="icoHome3"
          d="M14.2,26h-3.9v-6.7c0.3-0.1,1-0.4,1.9-0.4c1,0,1.8,0.3,2.1,0.4C14.2,21.5,14.2,23.8,14.2,26z"
        />
        <rect x="10.5" y="19.4" className="icoHome4" width="3.5" height="6.6" />
        <path
          className="icoHome5"
          d="M24.6,15.8c-7.5,0-15.1,0-22.6,0c0.3-2,0.9-4.2,1.6-6.6C4,8,4.5,6.9,4.9,5.9c7,0.1,14,0.1,21.1,0.2
c0.5,1.2,0.9,2.1,1.1,2.7c0.5,1.4,0.4,1.3,0.6,1.6c0.3,0.8,0.4,0.9,0.3,1.2c0,0.3-0.2,0.5-1,1.5c-0.4,0.5-0.8,0.9-0.9,1
C25.7,14.6,25.2,15.1,24.6,15.8z"
        />
        <path
          className="icoHome6"
          d="M22.1,23.7h-6.1c0-0.7,0-1.5,0-2.2c0-0.7,0-1.3,0-2c2,0,4.1,0,6.1,0V23.7z"
        />
        <path
          className="icoHome7"
          d="M21.8,23.6h-5.7c0-0.7,0-1.4,0-2.1c0-0.6,0-1.3,0-1.9c1.9,0,3.8,0,5.7,0V23.6z"
        />
        <path
          className="icoHome8"
          d="M23.3,8c-0.3,0.1-0.7,0.3-1.4,0.3c-0.6,0-1-0.2-1.3-0.3c0-2,0-4.1,0-6.1h2.6V8z"
        />
        <path
          className="icoHome0"
          d="M24.7,26c0.8-0.7,1.5-1.4,2.3-2.1c0.1-3.8,0.2-7.5,0.3-11.3c-0.8,0.9-1.7,1.9-2.5,2.8
C24.8,19,24.8,22.5,24.7,26z"
        />
        <path className="icoHome0" d="M36,16.6" />
        <path
          className="icoHome2"
          d="M27.8,24.4L25.3,27c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.1-0.3-0.3-0.3-0.3c0.8-0.9,1.7-1.8,2.5-2.6
c0.1,0.1,0.2,0.2,0.4,0.3C27.6,24.2,27.7,24.3,27.8,24.4z"
        />
        <rect x="24.5" y="15.7" className="st9" width="0.3" height="10.3" />
        <rect x="2.4" y="15.8" className="st9" width="0.3" height="10.2" />
        <circle className="icoHome10" cx="13.2" cy="23" r="0.3" />
        <path
          className="icoHome1"
          d="M27.3,23.9l-2.4,2.6c0,0-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0.8-0.9,1.6-1.7,2.4-2.6
c0,0,0.1,0.1,0.2,0.2C27.2,23.8,27.2,23.9,27.3,23.9z"
        />
      </svg>,
    ],
    icoTraining: [
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 28.3 28.3">
        <path
          className="icoTraining0"
          d="M7.1,24.2C7,24,6.7,23.8,6.4,23.5c-0.3-0.2-0.6-0.3-0.9-0.4c0,0,0-0.1,0-0.1c0-0.1,0.1-0.1,0.1-0.1
	c0.1-0.1,5.8-6.4,19.3-21.5c0.3,0.1,0.7,0.4,1.1,0.8c0.2,0.2,0.3,0.4,0.4,0.6c-6.3,7-12.6,14-18.9,21.1C7.4,23.9,7.2,24.1,7.1,24.2z
	"
        />
        <path
          className="icoTraining1"
          d="M4,26.1c0-0.1,0-0.2,0.1-0.4c0.1-0.1,0.1-0.2,0.1-0.2c0.1-0.2,0.4-0.8,1.2-2.6c0,0.1,0,0.2,0,0.3
	c0.1,0.1,0.4-0.3,0.6-0.2c0.1,0.1,0,0.2,0.1,0.4c0.2,0.2,0.7,0,0.8,0.2c0.1,0.1-0.1,0.3-0.1,0.4c0.1,0.1,0.4,0.1,0.4,0.2
	c0,0.1,0,0.2-0.3,0.3c-1.6,1-2.1,1.3-2.3,1.4c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2,0.1-0.2,0.2-0.3,0.2C4.1,26.1,4.1,26.1,4,26.1z"
        />
        <path className="icoTraining0" d="M6.8,24.3" />
        <path
          className="icoTraining0"
          d="M3.7,26.6c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0.2-0.2,0.3-0.3,0.5-0.5c0,0,0,0,0,0.1c0,0,0.1,0,0.1,0
	C4,26.3,3.9,26.5,3.7,26.6z"
        />
        <path
          className="icoTraining2"
          d="M7,23.8c0-0.1-0.1-0.2-0.3-0.3c-0.2-0.1-0.3-0.1-0.5-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1
	c0.1-0.1,5.7-6.3,19-21.1c0.2,0,0.4,0.1,0.5,0.3c0.1,0.1,0.1,0.2,0.1,0.3C19.8,9.6,13.6,16.5,7.4,23.3C7.3,23.5,7.1,23.6,7,23.8z"
        />
      </svg>,
    ],
  },
  Sea: [
    <svg version="1.1" id="sea" x="0px" y="0px" viewBox="0 0 100 20">
      <path
        className="sea0"
        id="sea0Id00"
        d="M100,5.58H0.04C0.03,4.57,0.02,3.55,0.01,2.53c4.83,0.05,11.27,0.1,18.88,0.15c7.32,0.05,16.1,0.1,26.68,0.11  C56.28,2.79,59,2.74,78.89,2.68c8.96-0.03,16.29-0.04,21.09-0.05C99.99,3.61,100,4.6,100,5.58z"
      />
      <path
        className="sea1"
        id="sea1Id00"
        d="M100,7.5H0V2.93c2.94,0.05,7.58,0.14,13.29,0.29C28.6,3.59,31.2,3.83,38.93,3.87
	c8.71,0.04,6.83-0.25,20.36-0.37C70.16,3.41,73.18,3.58,82.6,3.44C90.01,3.33,96.05,3.1,100,2.93C100,4.45,100,5.98,100,7.5z"
      />
      <path
        className="sea2"
        d="M19.38,7.68c-2.24-0.16-4-0.12-5.17-0.06c-1.96,0.11-2.92,0.32-4.78,0.29c-1.6-0.02-2.88-0.21-3.7-0.35
	c1.15,0.13,4.23,0.4,6.95-0.23c0.43-0.1,0.8-0.21,1.13-0.33c0.51,0.09,1.05,0.17,1.63,0.25C16.85,7.45,18.18,7.59,19.38,7.68z"
      />
      <path
        className="sea2"
        d="M90.13,9.82C81.29,10.41,78,10.11,76.75,9.66c-0.32-0.11-1.64-0.61-3.51-0.69c-0.48-0.02-0.62,0.01-1.65,0.06
	c-0.93,0.05-2.27,0.09-3.93,0.08c1.98-0.2,3.97-0.39,5.95-0.59c0.78,0.29,1.71,0.57,2.82,0.82C81.97,10.58,87.98,10.06,90.13,9.82z"
      />
      <path
        className="sea2"
        d="M53.92,10.74c-3.77,0.65-6.17,0.55-7.68,0.33c-0.94-0.14-1.53-0.26-2.93-0.45c-1.03-0.14-2.62-0.25-4.86-0.05
	c1.67-0.18,3.33-0.35,5-0.53c0.55,0.26,1.46,0.61,2.79,0.85C49.81,11.55,53.37,10.86,53.92,10.74z"
      />
      <path
        className="sea2"
        d="M93.6,6.88c-0.59,0.07-1.45,0.15-2.47,0.1c-0.87-0.04-1.42-0.15-1.83-0.21c-2.59-0.4-5.58,0.15-5.61,0.11
	c-0.01-0.02,0.85-0.14,4.39-0.54c0.49,0.15,1.38,0.37,2.64,0.49C91.97,6.96,93.01,6.92,93.6,6.88z"
      />
      <path
        className="sea2"
        d="M59.28,6.3c-1.1,0.16-1.91,0.14-2.44,0.09c-0.78-0.07-0.94-0.19-1.69-0.22c-0.89-0.03-1.5,0.1-2.12,0.19
	c-2.31,0.35-4.54,0.12-4.54,0.11c0-0.01,2.3,0.13,4.8-0.29c0.75-0.13,1.34-0.27,1.75-0.39c0.47,0.1,1.05,0.21,1.75,0.31
	C57.74,6.24,58.61,6.29,59.28,6.3z"
      />
      <path
        className="sea2"
        d="M33.75,6.47c0.1,0.02-1.07-0.16-2.48-0.19c-1.38-0.03-2.31,0.12-3.04,0.2c-1.25,0.13-3.12,0.18-5.82-0.21
	c1.7,0.16,4.5,0.31,7.43-0.14c0.48-0.07,0.91-0.16,1.32-0.25C32.02,6.08,32.89,6.28,33.75,6.47z"
      />
      <path
        className="sea2"
        d="M87.82,16.72c-0.04,0.03-2.55-0.74-5.26-0.51c-0.94,0.08-2.15,0.3-4.29,0.32c0,0-0.3,0-0.62,0
	c-1-0.01-2.94-0.08-5.73-0.55c1.29,0.21,4.51,0.65,8.12,0.21c1.02-0.12,1.88-0.29,2.57-0.47C86.87,16.5,87.84,16.7,87.82,16.72z"
      />
      <path
        className="sea2"
        d="M32.14,15.89c-10.39-1.3-14.44-1.24-16.05-0.86c-0.26,0.06-1.24,0.32-2.61,0.34c-1.61,0.02-2.95-0.29-3.82-0.55
	c1.17,0.15,3.55,0.37,6.2,0.04c0.75-0.09,1.39-0.22,1.92-0.34c1.27,0.04,2.61,0.1,4.02,0.19C25.84,14.96,29.31,15.41,32.14,15.89z"
      />
      <path
        className="sea2"
        d="M60.34,15.72c-2.98,0.39-4.9,0.27-6.11,0.07c-0.82-0.13-1.41-0.31-2.59-0.37c-1.59-0.07-2.43,0.16-3.58,0.22
	c-1.21,0.06-2.98-0.05-5.39-0.87c1.31,0.29,4.31,0.83,7.73,0.52c0.61-0.06,1.17-0.13,1.66-0.22c0.6,0.18,1.4,0.38,2.43,0.53
	C57.01,15.98,59.29,15.83,60.34,15.72z"
      />
      <path
        className="sea3"
        id="sea3Id00"
        d="M100,20H0V4.36c2.54-0.11,6.35-0.23,11-0.19c5.43,0.05,7.67,0.28,12.33,0.44c7.21,0.26,7.08-0.1,19.89-0.11  c9.24-0.01,9.14,0.18,17.11,0.11c9.03-0.08,8.62-0.32,14.11-0.22c6.89,0.12,9.29,0.53,15.67,0.44c4.24-0.05,7.68-0.29,9.89-0.48  C100,9.57,100,14.79,100,20z"
      />
      <path
        className="sea2"
        id="sea2Id04"
        d="M13.71,7.58c-0.01,0.06-0.89-0.04-2.62,0c-0.11,0-0.63,0.02-1.34,0.05C8.97,7.67,8.39,7.72,8.18,7.74  C4.74,8.02,2.8,8.18,2.79,8.08c-0.01-0.09,1.76-0.4,2.29-0.49c0.97-0.17,1.73-0.26,2.12-0.3c0.74-0.08,1.32-0.15,2.13-0.16  c0.19,0,0.81-0.01,1.66,0.05C12.38,7.27,13.72,7.5,13.71,7.58z"
      />
      <path
        className="sea2"
        id="sea2Id00"
        d="M43.75,8.46c0,0.07-1.16,0.3-2.73,0.21c-1.63-0.08-2.15-0.42-3.8-0.7c-2.5-0.42-4.27-0.15-4.27-0.24
	c0-0.07,0.83-0.21,4.81-0.56c0.41,0.22,1.01,0.51,1.77,0.75C41.81,8.66,43.75,8.38,43.75,8.46z"
      />
      <path
        className="sea2"
        id="sea2Id02"
        d="M95.32,16.61c0.01,0.08-2.79,0.45-3.39,0.54c-1.52,0.2-2.28,0.3-3.14,0.36c-0.45,0.03-2.12,0.12-4.43-0.14  c-4.35-0.49-7.95-1.88-7.94-1.91c0,0,0.09,0.02,0.59,0.15c1.66,0.4,4.26,1.04,7.31,1.34c1.08,0.11,2.52,0.2,4.25,0.18  C94.07,16.61,95.32,16.55,95.32,16.61z"
      />
      <path
        className="sea2"
        id="sea2Id03"
        d="M23,11.18c-0.01,0.06-1.51-0.21-4.43-0.48c-0.37-0.04-3.65-0.33-5.93-0.16c-0.87,0.07-1.68,0.2-1.68,0.2  c-0.59,0.09-1.03,0.19-1.52,0.3c-0.51,0.11-1.18,0.28-1.96,0.5c0.8-0.37,2.03-0.87,3.59-1.2c2.51-0.52,4.54-0.32,6.96-0.05  C20.74,10.58,23.01,11.11,23,11.18z"
      />
      <path
        className="sea2"
        id="sea2Id01"
        d="M60.34,15.38c0,0-0.02,0-0.02,0c-0.69,0.05-2.52,0.38-4.04,0.33c-1.55-0.06-2.74-0.52-4.81-1.33
	c-1.15-0.45-2.71-1.14-4.47-2.17c3.66,2.06,6.58,2.69,8.62,2.87C56.89,15.19,60.34,15.35,60.34,15.38z"
      />
    </svg>,
  ],
  beat: [
    <svg version="1.1" id="boat" x="0px" y="0px" viewBox="0 0 40 40">
      <path className="beat0" d="M10.88,4.99c-0.25,0.98-0.51,1.96-0.76,2.95" />
      <rect
        x="11.04"
        y="6.33"
        transform="matrix(0.9964 -0.0847 0.0847 0.9964 -0.4843 1.4529)"
        className="beat1"
        width="11.68"
        height="0.2"
      />
      <rect x="11.13" y="18.87" className="beat2" width="15.61" height="0.32" />
      <path
        className="beat3"
        d="M39.43,26.51c-4.32,0.59-7.97,0.84-10.77,0.95c-4.39,0.17-7.39,0-8.34-0.06c-3.62-0.22-6.31-0.64-8.46-0.97
   c-2.93-0.46-6.72-1.18-11.12-2.34c5.78,0.11,10.49,0.29,13.73,0.38c3.24,0.09,8.41,0.25,14.5,0.31c2.14,0.02,5.09,0.03,8.63,0
   C38.21,25.35,38.82,25.93,39.43,26.51z"
      />
      <path
        className="beat4"
        d="M5.41,31.87c-0.64-0.66-1.4-1.97-2.92-4.58c-0.78-1.34-1.37-2.46-1.76-3.21c1.15,0.23,2.88,0.58,5.01,1.02
   c3.09,0.65,3.86,0.85,5.24,1.1c3.41,0.6,6.07,0.86,7.22,0.96c4.75,0.41,8.38,0.29,11.31,0.17c2.67-0.1,6.03-0.33,9.91-0.83
   c-0.04,0.25-0.11,0.65-0.18,1.16c-0.09,0.61-0.1,0.73-0.19,0.92c-0.16,0.33-0.37,0.47-1,0.92c-1.23,0.88-1.01,0.77-1.42,1.03
   c-0.58,0.37-1.08,0.62-1.59,0.88c-0.19,0.1-0.31,0.16-0.48,0.23c-0.25,0.11-0.61,0.25-1.46,0.53c-1.47,0.48-3.81,1.29-5.45,1.6
   c-3.4,0.65-4.49,0.08-11.2-0.31C8.84,33.04,7.07,33.59,5.41,31.87z"
      />
      <path
        className="beat5"
        d="M37.27,32.2c-0.13,0.07-0.38-0.07-0.65-0.22c-0.37-0.21-0.38-0.29-0.72-0.46c-0.18-0.09-0.42-0.19-0.65-0.11
   c-0.01,0-0.01,0-0.02,0.01c-0.04,0.02-0.12,0.09-0.4,0.62c-0.1,0.18-0.24,0.4-0.47,0.66c-0.06,0.06-0.24,0.27-0.4,0.39
   c-0.71,0.55-1.88-0.47-3.5-0.09c-0.15,0.04-0.06,0.03-0.57,0.18c-0.75,0.23-1.27,0.35-2.08,0.54c0,0-1.27,0.29-2.06,0.29
   c0,0,0,0,0,0c0,0-0.84,0.1-1.68,0.09c-0.76-0.01-1.15-0.12-2.7-0.29c-0.37-0.04-0.91-0.08-1.99-0.17c-1.02-0.08-1.79-0.14-1.91-0.15
   c-2.27-0.17-7.73-0.1-9.83-0.49c-0.5-0.09-1.17-0.27-1.81-0.77c-0.06-0.05-0.21-0.16-0.41-0.37c-0.36-0.37-0.91-1.01-1.38-2.06
   c2.64,1.06,4.91,1.7,6.56,2.08c2.12,0.5,8.39,1.81,15.71,0.86c0.48-0.06,1.58-0.25,3.8-0.63c0,0,6.18-1.06,7.22-2.15
   c0,0,0.02-0.02,0.03-0.02c0.01,0,0.01,0.03,0,0.04c-0.01,0.04,0,0.09,0,0.13c0,0.03-0.01,0.33-0.02,0.93
   C37.31,31.92,37.4,32.13,37.27,32.2z"
      />
      <path
        className="beat6"
        d="M38.44,29.23c-0.52,0.41-1.32,0.97-2.39,1.47c-1.13,0.53-2.01,0.73-4.63,1.2c-3.03,0.55-4.55,0.82-5.7,0.95
   c-2.32,0.24-4.14,0.26-4.89,0.26c-5.71-0.01-10.24-1.15-12.6-1.86c-1.75-0.52-3.16-1.07-4.11-1.46c-0.33-0.48-0.65-0.96-0.98-1.43
   c7.13,2.18,13.2,2.85,17.46,3.03c8.65,0.36,13.39-1.11,15.05-1.68c1.48-0.51,2.68-1.03,3.51-1.43c-0.04,0.12-0.09,0.26-0.19,0.42
   C38.8,28.96,38.58,29.13,38.44,29.23z"
      />
      <path
        className="beat7"
        d="M39.17,28.08c-1.46,0.61-3.56,1.38-6.17,1.98c-1.47,0.34-5.6,1.21-12.74,0.86c-4.16-0.21-10.08-0.86-17.09-2.89
   c-0.26-0.41-0.52-0.82-0.78-1.23c4.26,1.41,10.41,2.94,17.92,3.15c7.95,0.22,14.48-1.11,18.93-2.38
   C39.22,27.75,39.19,27.92,39.17,28.08z"
      />
      <path
        className="beat8"
        d="M39.26,27.48c-2.88,0.77-6.1,1.42-9.64,1.81c-11.21,1.24-20.69-0.71-27.17-2.72c-0.32-0.69-0.63-1.38-0.95-2.06
   c6.96,2.08,16.4,3.93,27.5,3.35c3.75-0.2,7.22-0.65,10.37-1.23C39.33,26.91,39.29,27.2,39.26,27.48z"
      />
      <path
        className="beat9"
        d="M39.43,26.51c-1.49,0.23-3.48,0.51-5.84,0.74c-2.95,0.29-6.87,0.66-11.81,0.49c-6.08-0.22-10.77-1.15-13.96-1.8
   c-2.55-0.52-4.66-1.06-6.17-1.47c-0.3-0.11-0.59-0.22-0.89-0.33c2.71,0.54,4.9,0.99,6.39,1.3c2.65,0.55,4.13,0.87,6.43,1.22
   c3.65,0.56,6.46,0.68,7.94,0.74c7.14,0.3,13.7-0.52,17.61-1.15C39.23,26.34,39.33,26.42,39.43,26.51z"
      />
      <path
        className="beat10"
        d="M39.43,26.51c-0.27,0.03-0.54,0.06-0.82,0.1c-0.72-0.61-1.44-1.22-2.17-1.83c0.37,0,0.73,0.01,1.1,0.01
   C38.17,25.35,38.8,25.93,39.43,26.51z"
      />
      <path
        className="beat11"
        d="M37.79,25.02c-12.07-0.26-24.13-0.52-36.2-0.78c-0.26-0.05-0.52-0.1-0.78-0.14
   c12.25,0.22,24.5,0.44,36.76,0.66C37.64,24.84,37.71,24.93,37.79,25.02z"
      />
      <path
        className="beat12"
        d="M4.37,29.93c-0.14-0.05-0.27-0.11-0.41-0.16c-0.62-0.97-1.24-2.01-1.85-3.12C1.64,25.81,1.22,25,0.83,24.2
   c0.29,0.12,0.57,0.23,0.86,0.35c0.32,0.78,0.69,1.59,1.09,2.42C3.3,28.04,3.84,29.02,4.37,29.93z"
      />
      <path
        className="beat13"
        d="M21.71,33.61c3.33,0.08,5.46,0.1,5.47,0.23c0,0.09-1.01,0.19-1.53,0.23c-0.98,0.07-1.72,0.03-1.89,0.02
   c-2.41-0.16-8.22-0.62-10.17-0.7c-0.5-0.02-1.45-0.05-2.43-0.08c-0.3-0.01-0.59-0.02-0.89-0.02c-0.13,0-0.68,0.01-1.76-0.11
   c-0.4-0.05-0.85-0.11-1.36-0.27c0,0-0.58-0.18-1.02-0.45c-0.25-0.16-0.42-0.31-0.55-0.43c-0.54-0.49-1.02-1.24-1.02-1.25
   c0,0,0,0,0,0c-0.02-0.04-0.28-0.49-0.3-0.53c-0.02-0.03-0.24-0.42-0.25-0.44c0.14,0.05,0.27,0.11,0.41,0.16
   c0.21,0.5,0.6,1.22,1.32,1.8c1.4,1.15,3.16,1.12,4.1,1.09C13.79,32.76,17.74,33.51,21.71,33.61z"
      />
      <path
        className="beat14"
        d="M4.46,29.99c-0.05-0.03-0.1-0.06-0.15-0.1c-0.6-0.99-1.21-2.05-1.8-3.19c-0.39-0.76-0.76-1.5-1.09-2.22
   c0.1,0.05,0.19,0.1,0.29,0.14c0.32,0.78,0.68,1.6,1.11,2.45C3.35,28.15,3.91,29.12,4.46,29.99z"
      />
      <path
        className="beat15"
        d="M9.41,32.85c-0.19,0-0.39,0.01-0.58,0.01c-0.5-0.01-1.42-0.09-2.38-0.63c-0.17-0.09-0.8-0.46-1.39-1.17
   c-0.35-0.42-0.58-0.82-0.73-1.13c-0.01-0.01-0.01-0.01-0.01-0.02c0-0.01,0.05,0.02,0.14,0.07c0.11,0.22,0.26,0.5,0.5,0.81
   c0.21,0.28,0.72,0.91,1.56,1.39C7.72,32.88,8.91,32.88,9.41,32.85z"
      />
      <path
        className="beat16"
        d="M37.83,25.38c-11.59-0.29-23.18-0.58-34.77-0.87c-0.39-0.07-0.78-0.14-1.17-0.21
   c11.86,0.26,23.72,0.52,35.57,0.78C37.58,25.18,37.7,25.28,37.83,25.38z"
      />
      <path
        className="beat17"
        d="M29.65,25.26C22.44,25.37,15.22,25.48,8,25.58c-1.15-0.24-2.3-0.49-3.45-0.73c7.01,0.08,14.01,0.16,21.02,0.24
   C26.93,25.15,28.29,25.21,29.65,25.26z"
      />
      <path
        className="beat18"
        d="M38.19,26.36c-0.59,0.09-1.19,0.18-1.78,0.27c0.09-0.55,0.18-1.1,0.27-1.65c0.61-0.04,1.21-0.09,1.82-0.13
   C38.39,25.36,38.29,25.86,38.19,26.36z"
      />
      <path
        className="beat19"
        d="M38.5,24.85c-0.61,0.04-1.21,0.09-1.82,0.13c-0.03-0.04-0.06-0.08-0.1-0.12c0.61-0.03,1.21-0.06,1.82-0.09
   C38.43,24.8,38.46,24.83,38.5,24.85z"
      />
      <path
        className="beat19"
        d="M36.41,26.63c-0.04,0.01-0.08,0.02-0.12,0.03c0.1-0.6,0.19-1.2,0.29-1.8c0.03,0.04,0.06,0.08,0.1,0.12
   c-0.05,0.3-0.1,0.59-0.15,0.9C36.48,26.13,36.44,26.38,36.41,26.63z"
      />
      <path
        className="beat20"
        d="M12.63,26.46c0.33,0.04,0.66,0.08,0.99,0.12c-0.03-1.23-0.06-2.46-0.09-3.69c-0.14-0.04-0.3-0.07-0.49-0.1
   c-0.16-0.02-0.31-0.02-0.43-0.02C12.62,24,12.62,25.23,12.63,26.46z"
      />
      <path
        className="beat21"
        d="M31.81,27.17c-0.31,0.02-0.63,0.04-0.94,0.06c0.1-1.17,0.19-2.35,0.29-3.52c0.13-0.03,0.29-0.05,0.47-0.06
   c0.15-0.01,0.29-0.01,0.41,0C31.96,24.82,31.88,25.99,31.81,27.17z"
      />
      <path
        className="beat22"
        d="M13.39,26.51c0.08,0.02,0.15,0.05,0.23,0.07c-0.03-1.23-0.06-2.46-0.09-3.69c-0.07-0.01-0.13-0.02-0.2-0.04
   C13.35,24.07,13.37,25.29,13.39,26.51z"
      />
      <path
        className="beat23"
        d="M31.78,27.17c-0.08,0-0.16,0.01-0.25,0.01c0.08-1.18,0.16-2.36,0.24-3.55c0.08,0,0.15,0.01,0.23,0.01
   C31.92,24.82,31.85,26,31.78,27.17z"
      />
      <path
        className="beat24"
        d="M9.08,26.18c-1.35-0.33-2.44-0.56-3.19-0.7c-1.16-0.22-2.52-0.45-4.25-1.05c-0.2-0.07-0.85-0.29-0.83-0.34
   c0.02-0.07,1.47,0.28,2.48,0.51c1.38,0.31,3.3,0.69,5.7,0.99C9.02,25.79,9.05,25.99,9.08,26.18z"
      />
      <path
        className="beat25"
        d="M9.18,26.09c-0.04,0.03-0.07,0.05-0.11,0.08C9.05,25.98,9.02,25.78,9,25.59c0.03-0.01,0.06-0.02,0.09-0.04
   C9.12,25.73,9.15,25.91,9.18,26.09z"
      />
      <path
        className="beat25"
        d="M8.99,25.59c-0.65-0.08-1.33-0.17-2.03-0.28c-0.44-0.07-0.87-0.15-1.28-0.23c-0.36-0.08-0.73-0.15-1.09-0.23
   c1.5,0.23,3,0.47,4.5,0.7C9.06,25.57,9.02,25.58,8.99,25.59z"
      />
      <path
        className="beat26"
        d="M30.77,26.58c-4.72-0.03-9.44-0.06-14.15-0.1C16.41,26,16.2,25.51,16,25.02c4.51,0.06,9.01,0.13,13.52,0.19
   C29.94,25.67,30.35,26.12,30.77,26.58z"
      />
      <path
        className="beat27"
        d="M16.94,26.73c0,0.1-0.01,0.2-0.01,0.3c-0.04-0.11-0.09-0.21-0.13-0.32c-0.01-0.03-0.03-0.08-0.02-0.14
   c0.01-0.03,0.02-0.06,0.03-0.08C16.85,26.57,16.9,26.65,16.94,26.73z"
      />
      <rect
        x="16.61"
        y="26.49"
        className="beat28"
        width="14.08"
        height="0.27"
      />
      <path
        className="beat29"
        d="M16.64,26.49c-0.01,0.09-0.02,0.18-0.02,0.27c-0.19-0.57-0.39-1.14-0.58-1.71c0.01-0.03,0.01-0.06,0.02-0.1
   C16.25,25.46,16.44,25.98,16.64,26.49z"
      />
      <path
        className="beat30"
        d="M30.47,27.24c-2.01,0.16-4.22,0.26-6.6,0.23c-2.51-0.03-4.84-0.2-6.94-0.43c0-0.09,0-0.18,0-0.28
   c4.51,0,9.02-0.01,13.53-0.01C30.47,26.91,30.47,27.07,30.47,27.24z"
      />
      <path
        className="beat31"
        d="M24.05,20.41c1.92,0,3.84,0,5.75,0c-0.15,1.91-0.31,3.82-0.46,5.73c-1.88,0-3.76,0-5.64,0
   C23.82,24.23,23.94,22.32,24.05,20.41z"
      />
      <path
        className="beat32"
        d="M17.65,19.84c2.18,0.02,4.37,0.04,6.55,0.07c-0.12,2.12-0.24,4.25-0.36,6.37c-2.09,0-4.19,0.01-6.28,0.01
   C17.58,24.14,17.61,21.99,17.65,19.84z"
      />
      <path
        className="beat33"
        d="M17.59,19.89c4.08,0,8.15-0.01,12.23-0.01c0,0.19,0,0.39,0,0.58c-4.07,0.01-8.14,0.03-12.21,0.04
   C17.6,20.3,17.6,20.09,17.59,19.89z"
      />
      <path
        className="beat34"
        d="M29.82,19.89c-1.81,0-3.63,0.01-5.44,0.01c-0.24-0.2-0.48-0.41-0.73-0.61c1.63,0.03,3.26,0.06,4.9,0.09
   C28.97,19.55,29.39,19.72,29.82,19.89z"
      />
      <path
        className="beat35"
        d="M26.57,26.12h-0.61c0.17-1.9,0.35-3.81,0.52-5.71c0.19,0,0.37,0,0.56,0C26.87,22.32,26.72,24.22,26.57,26.12z"
      />
      <ellipse className="beat36" cx="26.76" cy="22.11" rx="0.73" ry="0.74" />
      <ellipse className="beat37" cx="26.75" cy="22.1" rx="0.53" ry="0.55" />
      <path
        className="beat38"
        d="M24.37,19.9c-2.23,0-4.47,0-6.7,0c-0.23-0.21-0.46-0.41-0.69-0.62c2.22,0,4.45,0.01,6.67,0.01
   C23.89,19.5,24.13,19.7,24.37,19.9z"
      />
      <path
        className="beat39"
        d="M17.55,26.32c-0.2-0.37-0.41-0.75-0.61-1.12c0.03-1.95,0.06-3.91,0.1-5.86c0.21,0.19,0.42,0.37,0.63,0.56
   C17.63,22.04,17.59,24.18,17.55,26.32z"
      />
      <path
        className="beat36"
        d="M21.62,23.55c-0.08,0.03-0.18,0.05-0.3,0.06c-0.16,0.01-0.29-0.01-0.39-0.03c-0.02-0.39-0.02-0.8-0.01-1.23
   c0.01-0.33,0.03-0.64,0.05-0.95c0.09-0.03,0.22-0.05,0.37-0.05c0.16,0,0.29,0.03,0.38,0.05c0.01,0.27,0.01,0.54,0,0.83
   C21.71,22.7,21.67,23.14,21.62,23.55z"
      />
      <path
        className="beat40"
        d="M21.56,23.1c-0.18,0.01-0.36,0.01-0.55,0.02c0.01-0.52,0.02-1.04,0.03-1.57c0.2,0,0.39,0,0.59,0
   C21.61,22.07,21.58,22.58,21.56,23.1z"
      />
      <path
        className="beat2"
        d="M33.24,26.04c-0.04,0.04-0.11,0.1-0.21,0.11c-0.12,0.02-0.21-0.03-0.26-0.06c0.01-5.09,0.01-10.18,0.02-15.26
   c0.02-0.04,0.1-0.19,0.24-0.22c0.14-0.02,0.23,0.09,0.26,0.12C33.27,15.84,33.26,20.94,33.24,26.04z"
      />
      <path
        className="beat2"
        d="M11.26,25.98c-0.04,0.05-0.11,0.14-0.21,0.17c-0.17,0.05-0.3-0.09-0.34-0.14c0-7-0.01-14.01-0.01-21.01
   c0.06-0.06,0.16-0.15,0.28-0.18c0.15-0.04,0.27,0.01,0.34,0.05C11.29,11.91,11.27,18.95,11.26,25.98z"
      />
      <path
        className="beat36"
        d="M19.48,23.49c-0.08,0.03-0.18,0.05-0.3,0.06c-0.16,0.01-0.29-0.01-0.39-0.03c-0.02-0.39-0.02-0.8-0.01-1.23
   c0.01-0.33,0.03-0.64,0.05-0.95c0.09-0.03,0.22-0.05,0.37-0.05c0.16,0,0.29,0.03,0.38,0.05c0.01,0.27,0.01,0.54,0,0.83
   C19.57,22.64,19.53,23.08,19.48,23.49z"
      />
      <path
        className="beat35"
        d="M25.15,26.18h-0.61c0.17-1.9,0.35-3.81,0.52-5.71c0.19,0,0.37,0,0.56,0C25.45,22.37,25.3,24.28,25.15,26.18z"
      />
      <path
        className="beat40"
        d="M19.42,22.96c-0.18,0.01-0.36,0.01-0.55,0.02c0.01-0.51,0.02-1.02,0.03-1.53c0.2,0,0.39,0,0.59,0
   C19.47,21.95,19.44,22.45,19.42,22.96z"
      />
      <path
        className="beat1"
        d="M11.1,25.97c-0.02,0.05-0.04,0.14-0.08,0.17c-0.07,0.05-0.12-0.09-0.13-0.14c0-7,0-14.01-0.01-21.01
   c0.02-0.06,0.06-0.15,0.11-0.18c0.06-0.04,0.1,0.01,0.13,0.05C11.11,11.9,11.1,18.93,11.1,25.97z"
      />
      <path
        className="beat35"
        d="M29.16,26.14h-0.61c0.17-1.9,0.35-3.81,0.52-5.71c0.19,0,0.37,0,0.56,0C29.46,22.34,29.31,24.24,29.16,26.14z"
      />
      <path
        className="beat35"
        d="M27.97,26.1h-0.61c0.17-1.9,0.35-3.81,0.52-5.71c0.19,0,0.37,0,0.56,0C28.27,22.3,28.12,24.2,27.97,26.1z"
      />
      <path
        className="beat41"
        d="M12.93,23.16c1.76,0.97,5.39,2.66,10.26,2.69c3.74,0.03,6.69-0.94,8.42-1.66"
      />
      <path
        className="beat42"
        d="M15.62,26.89c-0.55-0.08-1.1-0.15-1.65-0.23c-0.01-0.27-0.03-0.55-0.04-0.82c0.56,0.08,1.11,0.15,1.67,0.23
   C15.6,26.34,15.61,26.61,15.62,26.89z"
      />
      <ellipse
        transform="matrix(0.1096 -0.994 0.994 0.1096 -17.1264 38.6113)"
        className="beat43"
        cx="12.99"
        cy="28.86"
        rx="1.03"
        ry="1.01"
      />
      <ellipse className="beat43" cx="23.19" cy="29.73" rx="1.02" ry="1.04" />
      <ellipse className="beat43" cx="32.48" cy="29.06" rx="1.02" ry="1.04" />
      <ellipse
        transform="matrix(0.1096 -0.994 0.994 0.1096 -17.1909 38.6348)"
        className="beat44"
        cx="12.97"
        cy="28.91"
        rx="1.03"
        ry="1.01"
      />
      <ellipse
        transform="matrix(0.1096 -0.994 0.994 0.1096 -8.9751 49.487)"
        className="beat44"
        cx="23.13"
        cy="29.75"
        rx="1.03"
        ry="1.01"
      />
      <ellipse
        transform="matrix(0.1096 -0.994 0.994 0.1096 0.0423 58.1779)"
        className="beat44"
        cx="32.49"
        cy="29.07"
        rx="1.03"
        ry="1.01"
      />
      <path
        className="beat41"
        d="M11.05,5.06c-0.25,4.14-0.92,8.99-2.42,14.27c-0.59,2.09-1.26,4.04-1.96,5.84"
      />
      <path
        className="beat41"
        d="M36.41,26.63c-0.82-1.7-1.69-3.88-2.34-6.49c-0.68-2.74-0.92-5.17-0.98-7.12"
      />
      <path
        className="beat45"
        d="M16.93,27.03c-1.67-2.56-3.89-6.66-5.08-12.12c-0.87-3.98-0.91-7.47-0.74-10.05"
      />
      <path
        id="beat46Id00"
        className="beat46"
        d="M26.34,18.92c-2.15-0.34-4.73-0.6-7.62-0.57c-2.58,0.02-4.88,0.26-6.86,0.57c0.27-1.92,0.45-4.26,0.29-6.93
	c-0.12-1.95-0.39-3.69-0.71-5.19c1.38,0.39,3.71,0.86,6.53,0.46c1.8-0.26,3.26-0.79,4.31-1.27c0.94,1.09,2.24,2.89,3.15,5.4
	C26.56,14.58,26.49,17.37,26.34,18.92z"
      />
      <path className="beat0" d="M2.02,24.29c0.35-0.49,0.7-0.97,1.06-1.46" />
      <path
        className="beat47"
        d="M9.42,20.36c0.65,0.86,1.42,1.78,2.34,2.71c1.7,1.73,3.4,3,4.87,3.93"
      />
      <path
        id="beat46Id01"
        className="beat46"
        d="M9.61,20.51c-0.66,0.36-1.37,0.71-2.13,1.05c-1.73,0.77-3.36,1.29-4.81,1.66c1.45-2.05,3.02-4.61,4.47-7.68
   c1.49-3.16,2.47-6.09,3.14-8.57c0.2,2.71,0.23,5.81-0.09,9.2C10.05,17.7,9.85,19.15,9.61,20.51z"
      />
      <path className="beat46" d="M10.95,3.93" />
      <path
        className="beat48"
        d="M35.85,26.72c-1.1,0.1-2.2,0.2-3.3,0.31c0-0.09,0-0.17,0-0.26c1.11-0.1,2.22-0.19,3.34-0.29
   C35.88,26.55,35.86,26.63,35.85,26.72z"
      />
      <path
        className="beat49 baseAnimation"
        d="M2.32,29.38c0.31-0.19,0.77,0.65,1.92,0.87c1.32,0.25,1.8-0.64,3.01-0.44c1.26,0.21,1.16,1.26,2.46,1.71
	c1.64,0.57,2.37-0.89,4.34-0.54c1.8,0.32,1.85,1.65,3.43,1.71c1.67,0.06,2.12-1.41,3.75-1.23c1.37,0.15,1.44,1.22,2.73,1.29
	c1.52,0.08,1.84-1.37,3.59-1.45c1.28-0.06,1.5,0.71,2.84,0.59c0.92-0.08,1.19-0.48,2.57-1.18c1.66-0.85,3.55-1.81,4.45-1.12
	c0.75,0.57,0.66,2.15,0.21,3.16c0,0-0.28,0.64-0.8,1.12c-2.56,2.37-18.43,1.66-18.43,1.66C9.06,35.12,4.83,35.8,3.07,32.96
	C2.32,31.76,1.86,29.65,2.32,29.38z"
      />
      <path className="beat45" d="M13.05,28.32c0.04-0.4,0.09-0.8,0.13-1.21" />
      <path className="beat45" d="M23.26,29.12c0.03-0.38,0.05-0.77,0.08-1.15" />
      <path className="beat45" d="M32.5,28.35c0.04-0.32,0.09-0.64,0.13-0.96" />
      <path
        className="beat51"
        d="M27.5,27.42c-1.04,0.02-2.07,0.03-3.11,0.05c0-0.38-0.01-0.76-0.01-1.14c0.58,0.01,1.19,0,1.84-0.04  c0.44-0.03,0.87-0.06,1.27-0.11C27.49,26.59,27.49,27,27.5,27.42z"
      />
      <path
        className="beat52 baseAnimation"
        d="M25.06,26.32c-0.51-0.41-0.77-0.81-0.91-1.11c-0.3-0.63-0.13-0.88-0.49-1.42c-0.31-0.46-0.55-0.44-0.8-0.94  c-0.19-0.39-0.07-0.45-0.27-0.89c-0.25-0.54-0.45-0.5-0.71-1.05c-0.23-0.49-0.1-0.58-0.33-0.88c-0.22-0.28-0.43-0.32-0.57-0.63  c-0.13-0.29-0.09-0.53-0.1-0.53c-0.02,0-0.19,2.28-0.07,5.92c0.04,1.07,0.15,3.71,0.68,7.04c0.21,1.33,0.48,2.7,1.32,4.19  c0.62,1.1,1.48,1.78,2.06,2.22"
      />
      <path
        className="beat53"
        d="M20.7,18.52c-0.01,0.01,0.87,1.75,2.09,3.86c0.49,0.85,0.84,1.49,1.04,1.85c0.42,0.74,0.8,1.38,1.11,1.9  c0.1,0.17,0.18,0.31,0.24,0.41c0.07-0.01,0.13-0.03,0.2-0.04c-0.38-0.59-0.87-1.38-1.45-2.33c-0.23-0.37-0.56-0.94-1.08-1.84  C21.53,20.05,20.71,18.52,20.7,18.52z"
      />
    </svg>,
  ],
  moon: [
    <svg version="1.1" id="moon" x="0px" y="0px" viewBox="0 0 10 10">
      <circle className="moon0" cx="4.99" cy="4.99" r="4.95" />
      <path
        className="moon1"
        d="M8.98,6.57C8.72,6.38,8.46,6.2,8.21,6.01C7.37,4.85,7.11,4.65,7.03,4.7C6.96,4.73,7.01,4.99,7.11,5.5
c0.09,0.44,0.16,0.69,0.13,0.7C7.18,6.22,6.97,4.48,5.9,4C5.43,3.79,5.08,3.95,4.75,3.62C4.43,3.31,4.41,2.81,4.43,2.47
c0.14-0.24,0.42-0.66,0.94-0.94c0.19-0.1,0.49-0.26,0.88-0.24c0.41,0.02,0.67,0.24,1.1,0.56c0.35,0.26,0.85,0.63,1.5,1.07
C9.01,3.26,9.2,3.75,9.28,4.38C9.39,5.37,9.14,6.17,8.98,6.57z"
      />
      <path
        className="moon2"
        d="M0.28,5.55c0.02-0.3,0.06-0.8,0.13-1.31c0.02-0.11,0.06-0.27,0.13-0.59C0.63,3.31,0.66,3.23,0.73,3.2
c0.1-0.04,0.23,0.05,0.51,0.27c0.13,0.1,0.36,0.27,0.67,0.51c0.45-1.03,1.12-1.62,1.58-1.5C3.74,2.54,3.92,2.8,4.08,3.04
C4.25,3.29,4.49,3.64,4.4,4C4.33,4.28,4.14,4.28,4.11,4.56c-0.04,0.3,0.17,0.41,0.08,0.64C4.13,5.36,4.03,5.34,3.84,5.58
c-0.08,0.1-0.21,0.28-0.21,0.48c-0.01,0.38,0.46,0.72,0.59,0.8c0.45,0.31,0.75,0.22,0.91,0.51C5.2,7.51,5.19,7.65,5.18,7.94
C5.16,8.3,5.15,8.57,4.96,8.77C4.65,9.12,4.05,9,3.81,8.96C3.75,8.94,3.17,8.83,3.14,8.58C3.13,8.47,3.23,8.39,3.27,8.33
C3.4,8.09,2.7,7.32,0.28,5.55z"
      />
      <path
        className="moon3"
        d="M6.17,4.96C6.09,4.91,5.89,4.74,5.82,4.46C5.74,4.1,5.9,3.71,6.22,3.46c0.21,0.15,0.43,0.3,0.64,0.46
c0.19,0.19,0.26,0.45,0.19,0.67C6.95,4.9,6.56,5.09,6.17,4.96z"
      />
      <path
        className="moon4"
        d="M8.79,3.73C8.76,3.69,8.34,3.17,7.75,3.25c-0.2,0.03-0.36,0.12-0.46,0.19C7.2,3.15,7.1,2.87,7,2.58
c0.81-0.06,1.33,0.07,1.61,0.16c0.15,0.05,0.3,0.12,0.38,0.27C9.1,3.23,9.03,3.54,8.79,3.73z"
      />
      <path
        className="moon5"
        d="M8.96,6.41C8.78,6.56,8.6,6.71,8.42,6.87C8.36,6.79,8.09,6.43,8.15,5.93c0.08-0.65,0.64-0.96,0.7-0.99
c0.09,0.09,0.18,0.18,0.27,0.27c0,0.15-0.01,0.33-0.03,0.51C9.06,5.98,9.01,6.21,8.96,6.41z"
      />
      <path
        className="moon6"
        d="M3.22,7.05C3.16,7.1,3.09,7.03,2.77,6.97C2.51,6.92,2.45,6.95,2.39,6.89c-0.08-0.08-0.05-0.19,0-0.59
c0.06-0.5,0.04-0.58,0.13-0.7c0.14-0.17,0.4-0.25,0.46-0.19c0.1,0.11-0.38,0.54-0.24,0.8c0.08,0.14,0.25,0.08,0.4,0.27
C3.3,6.67,3.33,6.97,3.22,7.05z"
      />
      <path
        className="moon7"
        d="M2.23,4.28c-0.13,0-0.32-0.02-0.54-0.11c-0.14-0.06-0.25-0.1-0.27-0.19C1.39,3.83,1.66,3.58,1.88,3.61
C2.09,3.64,2.28,3.92,2.23,4.28z"
      />
      <path
        className="moon8"
        d="M7.46,5.4C7.84,5.35,7.89,5.26,7.9,5.22c0.05-0.21-0.65-0.5-0.79-0.56C7.1,5.3,7.15,5.63,7.25,5.64
C7.3,5.65,7.37,5.57,7.46,5.4z"
      />
      <path
        className="moon9"
        d="M1.64,6.44c-0.25-0.09-0.5-0.18-0.75-0.27C0.84,6.04,0.8,5.88,0.76,5.71C0.72,5.55,0.7,5.4,0.68,5.26
C0.66,5.11,0.66,4.77,0.89,4.48C1.06,4.28,1.28,4.19,1.4,4.16c-0.08,0.15-0.37,0.7-0.21,1.39C1.28,6,1.51,6.29,1.64,6.44z"
      />
      <path
        className="moon10"
        d="M3.79,4.45c0.26-0.11,0.5-0.08,0.56,0.03c0.09,0.15-0.19,0.52-0.37,0.48C3.87,4.93,3.8,4.72,3.79,4.45z"
      />
      <path
        className="moon11"
        d="M8.85,4.43c0,0.21,0,0.31-0.05,0.38c-0.19,0.23-0.76,0.01-0.83,0C7.74,4.77,7.42,4.62,7.08,4.08
C7.2,3.96,7.31,3.85,7.43,3.73c0.12-0.23,0.25-0.28,0.32-0.29C7.89,3.41,7.96,3.5,8.37,3.65c0.28,0.11,0.31,0.09,0.38,0.16
C8.85,3.94,8.85,4.11,8.85,4.43z"
      />
      <path
        className="moon12"
        d="M6.2,8.07c0.07,0.7,0.04,1.08-0.11,1.12c-0.1,0.03-0.24-0.09-0.43-0.35c-0.07-0.3-0.14-0.61-0.21-0.91
C5.7,7.98,5.95,8.03,6.2,8.07z"
      />
      <path
        className="moon13"
        d="M4.56,6.57C4.09,6.82,3.83,6.76,3.71,6.71C3.58,6.65,3.58,6.59,3.25,6.36C2.98,6.17,2.9,6.14,2.89,6.06
c-0.01-0.17,0.4-0.2,0.5-0.5c0.08-0.24-0.11-0.43-0.01-0.52c0.1-0.09,0.28,0.11,0.59,0.08C4.3,5.09,4.48,4.82,4.56,4.88
C4.63,4.94,4.5,5.11,4.59,5.31C4.64,5.43,4.72,5.43,4.72,5.5c0.01,0.18-0.47,0.24-0.54,0.48C4.16,6.1,4.21,6.28,4.56,6.57z"
      />
      <path
        className="moon14"
        d="M9.84,5.61c0.02,0.01-0.11,1.13-0.9,2.11c-1.1,1.36-2.91,1.87-2.92,1.83c0,0,0.1-0.03,0.27-0.08
c0.55-0.18,1.67-0.68,2.53-1.74C9.66,6.69,9.82,5.6,9.84,5.61z"
      />
      <path
        className="moon12"
        d="M5.85,7.91c-0.3-0.23-0.37-0.54-0.27-0.67C5.7,7.09,6.1,7.12,6.2,7.32C6.27,7.47,6.14,7.73,5.85,7.91z"
      />
      <path
        className="moon15"
        d="M4.32,4.13C4.21,4.2,4.05,4.28,3.83,4.31c-0.2,0.03-0.34,0.08-0.43,0C3.29,4.22,3.32,3.96,3.46,3.7
c0.35-0.05,0.7-0.11,1.04-0.16C4.44,3.73,4.38,3.93,4.32,4.13z"
      />
      <path
        className="moon15"
        d="M6.95,3.76C6.71,3.76,6.5,3.62,6.44,3.41C6.37,3.17,6.53,2.97,6.54,2.96c0.26-0.2,0.38-0.15,0.4-0.13
C7.1,2.9,7.11,3.27,6.95,3.76z"
      />
      <path
        className="moon16"
        d="M2.23,5.31c-0.17,0.1-0.52,0.2-0.75,0C1.35,5.19,1.29,5,1.32,4.83c0.05-0.27,0.37-0.5,0.75-0.46
C2.26,4.48,2.45,4.59,2.63,4.7C2.63,4.75,2.57,5.12,2.23,5.31z"
      />
      <path
        className="moon17"
        d="M2.37,3.57C1.95,3.6,1.65,3.35,1.64,3.12C1.64,2.91,1.87,2.71,2.1,2.66C2.32,2.61,2.5,2.71,2.55,2.74
C2.49,3.02,2.43,3.29,2.37,3.57z"
      />
      <path
        className="moon18"
        d="M6.65,8.26C6.5,8.11,6.35,7.97,6.2,7.82c0.09-0.4,0.34-0.63,0.51-0.61C6.84,7.23,6.96,7.42,7,7.65
C6.88,7.85,6.77,8.06,6.65,8.26z"
      />
      <path
        className="moon19"
        d="M5.42,4.96c-0.13-0.38-0.27-0.75-0.4-1.13c0.2,0.95,0.39,1.89,0.59,2.84c-0.03-0.27-0.05-0.54-0.08-0.8
C5.49,5.57,5.46,5.27,5.42,4.96z"
      />
      <path
        className="moon3"
        d="M3.25,3.67c-0.21,0.1-0.43,0.2-0.64,0.3C2.65,3.7,2.7,3.42,2.75,3.14c0.11,0.05,0.24,0.09,0.39,0.11
c0.28,0.04,0.52-0.02,0.67-0.08C3.63,3.34,3.44,3.51,3.25,3.67z"
      />
      <path
        className="moon20"
        d="M7.95,6.39c0.09-0.41,0.18-0.81,0.26-1.22C7.86,6.09,7.51,7.02,7.16,7.94C7.29,7.7,7.41,7.46,7.54,7.22
C7.68,6.94,7.82,6.66,7.95,6.39z"
      />
      <path
        className="moon21"
        d="M2.58,8.82C2.22,8.53,1.87,8.23,1.51,7.94C1.37,7.53,1.22,7.12,1.08,6.71C1.4,6.64,1.57,6.71,1.67,6.79
c0.22,0.16,0.14,0.4,0.4,0.83c0.17,0.27,0.26,0.27,0.38,0.51C2.57,8.39,2.59,8.64,2.58,8.82z"
      />
      <path
        className="moon21"
        d="M8.15,1.51C7.61,1.42,7.04,1.34,6.46,1.27C6.15,1.23,5.84,1.19,5.53,1.16C5.29,0.95,5.04,0.73,4.8,0.52
c0.22-0.08,0.56-0.17,0.99-0.16c0.43,0.01,0.78,0.11,0.99,0.19C7.24,0.87,7.7,1.19,8.15,1.51z"
      />
      <path
        className="moon21"
        d="M4.35,1.08C4.25,1.2,4.04,1.41,3.71,1.54C3.47,1.63,3.25,1.64,3.12,1.64c-0.05-0.13-0.11-0.27-0.16-0.4
c0.02-0.06,0.14-0.48,0.56-0.67C3.89,0.4,4.23,0.52,4.29,0.54C4.31,0.72,4.33,0.9,4.35,1.08z"
      />
      <path
        className="moon21"
        d="M5.82,2.82c-0.23,0.91-0.36,0.97-0.4,0.96C5.27,3.77,5.21,2.97,5.21,2.79c0-0.23,0-0.46,0-0.7h0.8
C5.95,2.34,5.88,2.58,5.82,2.82z"
      />
      <path
        className="moon12"
        d="M8.96,2.45C8.89,2.46,8.01,2.64,7.64,2.15C7.5,1.96,7.41,1.63,7.54,1.51c0.1-0.1,0.33-0.02,0.54,0.05
C8.18,1.6,8.39,1.69,8.61,1.88C8.72,1.98,8.86,2.15,8.96,2.45z"
      />
      <path
        className="moon12"
        d="M1.59,2.21C1.6,2,1.61,1.79,1.62,1.59C1.83,1.3,2.08,1.17,2.21,1.24c0.12,0.07,0.12,0.33,0.05,0.51
C2.11,2.13,1.62,2.2,1.59,2.21z"
      />
      <path
        className="moon12"
        d="M2.31,8.07C2.05,7.96,1.79,7.86,1.54,7.75c-0.25-0.27-0.5-0.54-0.75-0.8c0.03-0.05,0.13-0.18,0.29-0.24
c0.3-0.11,0.56,0.06,0.59,0.08C1.88,7.21,2.1,7.64,2.31,8.07z"
      />
      <path
        className="moon12"
        d="M3.6,2.71C3.36,2.83,3.18,2.84,3.06,2.82c-0.28-0.04-0.7-0.14-0.75-0.38C2.3,2.38,2.32,2.32,2.53,2.02
C2.81,1.61,2.95,1.4,3.04,1.4C3.33,1.4,3.54,2.44,3.6,2.71z"
      />
      <path
        className="moon17"
        d="M6.2,3.21C5.92,3.06,5.76,2.75,5.8,2.45c0.06-0.38,0.41-0.62,0.69-0.62c0.28,0,0.61,0.11,0.64,0.29
c0.02,0.1-0.06,0.19-0.29,0.43C6.58,2.82,6.36,3.04,6.2,3.21z"
      />
      <path
        className="moon22"
        d="M5.69,2.85C5.53,2.83,5.23,2.78,4.91,2.58C4.69,2.44,4.26,2.2,4.29,1.91c0.03-0.24,0.37-0.45,0.83-0.48
c0.3-0.01,0.67,0.02,0.75,0.21c0.04,0.1-0.02,0.2-0.08,0.37C5.73,2.2,5.67,2.48,5.69,2.85z"
      />
      <path
        className="moon23"
        d="M7.13,7.54C6.86,7.76,6.7,7.84,6.65,7.8c-0.08-0.07,0.18-0.56,0.8-1.45c0,0.12,0,0.25-0.03,0.4
C7.37,7.1,7.24,7.37,7.13,7.54z"
      />
      <path
        className="moon12"
        d="M6.49,9.17C6.47,9.15,6.3,8.93,6.38,8.69c0.08-0.23,0.34-0.29,0.46-0.32c0.3-0.07,0.67,0.02,0.7,0.16
C7.56,8.64,7.36,8.83,6.49,9.17z"
      />
      <path
        className="moon12"
        d="M4.05,9.71c-0.16-0.02-0.4-0.08-0.67-0.21C3.12,9.35,2.93,9.18,2.82,9.06c-0.15-0.14-0.3-0.29-0.46-0.43
c0.15-0.03,0.37-0.05,0.64,0c0.34,0.06,0.59,0.2,0.72,0.29C3.76,9.05,3.8,9.2,3.87,9.36C3.93,9.5,3.99,9.61,4.05,9.71z"
      />
      <path
        className="moon12"
        d="M4.72,1.13C4.53,1.03,4.27,0.9,3.95,0.81c-0.31-0.09-0.59-0.12-0.8-0.13C3.23,0.59,3.32,0.5,3.41,0.41
C3.77,0.36,4.12,0.3,4.48,0.25c0.26-0.04,0.49,0.14,0.54,0.38C5.05,0.83,4.93,1.05,4.72,1.13z"
      />
      <path
        className="moon24"
        d="M4.88,8.01C4.75,7.96,4.6,7.91,4.56,7.96C4.52,8.01,4.63,8.1,4.6,8.2C4.56,8.35,4.29,8.3,4.16,8.5
c-0.09,0.13-0.03,0.23-0.1,0.27C3.95,8.84,3.79,8.61,3.48,8.51C3.31,8.46,3.14,8.47,3.02,8.49c0.34-0.59,0.5-0.71,0.57-0.69
c0.04,0.02,0.05,0.08,0.14,0.14C3.76,7.97,3.9,8.06,3.99,8.02C4.1,7.97,4.12,7.71,4.06,7.51C3.98,7.24,3.77,7.14,3.82,7.02
C3.84,6.95,3.95,6.92,4.04,6.9c0.18-0.06,0.28-0.03,0.34,0.01c0.08,0.05,0.09,0.12,0.19,0.21C4.66,7.2,4.76,7.24,4.83,7.25
c-0.03,0.07-0.1,0.23-0.07,0.43C4.77,7.84,4.84,7.95,4.88,8.01z"
      />
      <path
        className="moon20"
        d="M9.41,3.6C9.15,3.27,8.89,2.94,8.63,2.61C8.81,2.85,9.05,3.23,9.2,3.76c0.19,0.68,0.14,1.26,0.08,1.58
C9.32,4.76,9.37,4.18,9.41,3.6z"
      />
      <path
        className="moon25"
        d="M8.33,7.88C8.25,8.06,8.08,8.17,7.9,8.18c-0.27,0.01-0.42-0.2-0.43-0.21c0.16-0.25,0.32-0.5,0.48-0.75
c0.19,0.11,0.37,0.21,0.56,0.32C8.45,7.65,8.39,7.77,8.33,7.88z"
      />
      <path
        className="moon12"
        d="M6.3,8.66C6.29,8.62,6.27,8.57,6.27,8.51c0-0.06-0.01-0.18,0.06-0.24c0.1-0.08,0.32,0.03,0.32,0.08
c0,0.03-0.06,0.03-0.15,0.08C6.4,8.49,6.34,8.58,6.3,8.66z"
      />
      <path
        className="moon12"
        d="M7.63,8.7C7.64,8.64,7.64,8.57,7.61,8.5C7.57,8.42,7.5,8.4,7.51,8.37c0.01-0.03,0.1-0.01,0.26-0.01
c0.18,0,0.25-0.03,0.26,0C8.05,8.4,7.95,8.48,7.88,8.53C7.78,8.61,7.69,8.66,7.63,8.7z"
      />
    </svg>,
  ],
  clouds: [
    [
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 10 10">
        <path
          className="clouds0class0"
          d="M9.81,5.28c-0.01,0.73-0.2,0.99-0.37,1.09C9.05,6.6,8.52,6.16,8.26,6.41C8.02,6.63,8.35,7.09,8.07,7.44
C7.87,7.68,7.53,7.7,7.45,7.71C6.89,7.74,6.78,7.28,6.21,7.3C5.75,7.32,5.43,7.55,5.43,7.55C5.27,7.67,5.21,7.78,5.08,7.78
c-0.18,0-0.25-0.19-0.49-0.41C4.53,7.33,4.26,7.1,3.95,7.04C3.43,6.94,3.14,7.4,2.84,7.27C2.7,7.21,2.56,7.04,2.52,6.53
C2.06,6.56,1.69,6.44,1.64,6.24c-0.05-0.17,0.12-0.4,0.28-0.62C2.04,5.46,2.19,5.3,2.19,5.3C2.18,5.29,1.94,5.68,1.64,5.68
c-0.19,0-0.36-0.16-0.44-0.32c-0.12-0.24,0.01-0.4-0.11-0.58C0.97,4.6,0.76,4.62,0.6,4.53C0.07,4.25-0.16,2.8,0.54,2.29
c0.49-0.36,1.25,0.02,1.33,0.06c0.68-0.89,1.15-1.03,1.46-0.98c0.55,0.09,0.62,0.79,1.33,0.98c0.61,0.16,0.99-0.28,1.43-0.04
c0.3,0.17,0.42,0.54,0.47,0.84c0.69-0.22,1.25-0.23,1.6-0.21c0.55,0.04,0.72,0.16,0.8,0.23C9.19,3.39,9.2,3.66,9.33,4.13
C9.41,4.42,9.56,4.82,9.81,5.28z"
        />
      </svg>,
    ],
    [
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 10 10">
        <path
          className="clouds1class0"
          d="M7.66,5.18c0,0.23-0.14,0.27-0.12,0.46C7.56,5.96,7.98,5.98,8.17,6.4C8.28,6.64,8.31,7,8.15,7.13
C7.98,7.27,7.73,7,7.32,7.07c-0.4,0.07-0.39,0.37-0.71,0.46C5.91,7.73,5.13,6.4,4.6,6.63C4.44,6.7,4.48,6.85,4.27,6.95
C3.92,7.11,3.36,6.94,3.12,6.58C2.94,6.31,3.08,6.14,3.03,5.34C2.98,4.51,2.8,4.4,2.94,4.18c0.29-0.46,1.11-0.11,1.52-0.65
c0.23-0.3,0.09-0.57,0.32-0.74c0.3-0.23,0.87,0.02,1.29,0.25C6.64,2.92,6.9,3.04,7.02,3.17c0.3,0.32-0.07,0.81,0.3,1.4
C7.47,4.8,7.66,4.92,7.66,5.18z"
        />
      </svg>,
    ],
    [
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 10 10">
        <path
          className="clouds2class0"
          d="M9.16,6.05C9.22,6.2,9.4,6.69,9.18,6.97C8.91,7.3,8.25,7.15,7.78,7.04C6.63,6.77,6.61,6.31,5.87,6.26
C4.96,6.19,4.81,6.88,3.84,6.77C3.19,6.7,3.01,6.35,2.39,6.45c-0.46,0.08-0.6,0.31-0.99,0.3C0.95,6.74,0.59,6.39,0.36,6.12
C0.4,5.8,0.5,5.32,0.82,4.86c0.52-0.73,1.53-1.31,2.12-1.02C3.26,3.99,3.4,4.37,3.47,4.33c0.09-0.05-0.31-0.59-0.12-0.95
c0.17-0.34,0.7-0.17,2.07-0.51c0.78-0.2,1.03-0.36,1.2-0.51c0.26-0.23,0.32-0.42,0.48-0.42c0.19-0.01,0.46,0.24,0.83,1.43
c0.22,0.06,0.59,0.18,0.94,0.48c0.2,0.17,0.8,0.69,0.72,1.4C9.54,5.63,9.31,5.91,9.16,6.05z"
        />
      </svg>,
    ],
    [
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 10 10">
        <path
          className="clouds3class0"
          d="M8.49,6.05C8.6,6.22,8.84,6.64,8.7,7.04c-0.24,0.67-1.42,0.89-2,0.51C6.37,7.32,6.36,6.96,6,6.88
C5.72,6.81,5.65,7.01,5.24,7.06c-0.58,0.07-0.73-0.29-1.4-0.28C3.37,6.78,3.37,6.97,3,6.93C2.42,6.88,1.8,6.37,1.76,5.84
c-0.03-0.37,0.23-0.5,0.21-0.87c-0.03-0.46-0.46-0.8-0.83-1.02c-0.06-0.1-0.26-0.47-0.18-0.95c0.01-0.08,0.1-0.56,0.49-0.87
c0.66-0.5,1.8-0.22,2.16,0.37c0.31,0.51-0.04,1.13,0.25,1.29C4.13,3.94,4.45,3.41,4.97,3.5c0.49,0.08,0.6,0.6,0.97,0.57
c0.32-0.03,0.37-0.43,0.71-0.53c0.23-0.07,0.59,0,1.18,0.6c0.08-0.02,0.49-0.12,0.85,0.12c0.43,0.29,0.57,0.91,0.34,1.34
C8.86,5.89,8.6,6.01,8.49,6.05z"
        />
      </svg>,
    ],
    [
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 10 10">
        <path
          className="clouds4class0"
          d="M9.53,5.29c0.02,0.18,0.04,0.48-0.06,0.82C9.37,6.43,9.28,6.75,9.02,6.87C8.52,7.11,8.01,6.28,7.2,6.43
C6.69,6.53,6.6,6.92,6.17,6.87C5.76,6.82,5.7,6.44,5.26,6.41C5.12,6.4,4.91,6.48,4.48,6.63C3.9,6.84,3.9,6.89,3.74,6.89
C3.28,6.9,3.24,6.5,2.72,6.37C2.26,6.25,2.14,6.53,1.24,6.53c-0.65,0-0.83-0.15-0.89-0.2C0.08,6.08,0.11,5.69,0.12,5.59
C0.19,5.02,0.8,4.57,1.31,4.58c0.27,0.01,0.28,0.14,0.53,0.14c0.62,0,0.8-0.85,1.35-0.9c0.47-0.04,0.55,0.55,1.29,0.82
c0.8,0.29,1.88,0.03,2.13-0.5c0.18-0.38-0.21-0.65,0-1.08C6.8,2.66,7.42,2.32,7.99,2.5c0.51,0.17,0.68,0.68,0.7,0.74
c0.44-0.35,0.71-0.28,0.76-0.26c0.44,0.14,0.49,1,0.4,1.52C9.78,4.85,9.64,5.12,9.53,5.29z"
        />
      </svg>,
    ],
    [
      <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 10 10">
        <path
          className="clouds5class0"
          d="M9.46,5.53C9.49,5.75,9.5,6.09,9.39,6.48C9.28,6.85,9.17,7.22,8.87,7.36C8.29,7.64,7.7,6.68,6.77,6.85
c-0.6,0.11-0.7,0.57-1.2,0.51C5.1,7.3,5.07,6.96,4.52,6.83C3.93,6.68,3.77,7.04,2.9,7.04c-0.5,0-0.87-0.12-1.32-0.26
C0.79,6.53,0.39,6.4,0.2,6.02c-0.29-0.58,0.12-1.27,0.14-1.31C0.6,4.3,0.99,4.12,1.1,4.08c0.54-0.23,0.89-0.04,1.02-0.25
c0.16-0.26-0.35-0.58-0.3-1.16c0.03-0.42,0.36-0.87,0.76-0.98C3,1.57,3.15,1.94,3.86,2.05c0.82,0.13,1.21-0.27,1.47-0.02
C5.71,2.38,5.2,3.42,5.39,3.5c0.13,0.05,0.31-0.4,0.69-0.55c0.54-0.22,1.27,0.26,1.89,0.82c0.98-0.18,1.76,0.3,1.86,0.84
C9.91,5.05,9.54,5.45,9.46,5.53z"
        />
      </svg>,
    ],
    [
      <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 10 10">
        <path
          className="clouds5class0"
          d="M9.34,5.47C9.01,5.61,8.61,5.32,8.18,5.51C7.83,5.66,7.93,5.92,7.61,6.02C7.3,6.12,7.07,5.91,6.35,5.77
C6.07,5.71,5.46,5.59,4.81,5.68C4.08,5.78,3.9,6.05,3.48,5.96C3.11,5.88,3.15,5.65,2.73,5.54C2.35,5.44,2.2,5.59,1.58,5.58
C1.25,5.57,0.7,5.56,0.39,5.3C0.07,5.02,0.04,4.52,0.35,4.34c0.51-0.3,1.57,0.51,2.34,0.21C3.36,4.3,3.04,3.49,3.68,3.31
c0.6-0.17,1.16,0.44,1.88,0.24C6.05,3.41,6.07,3.04,6.48,3c0.41-0.04,0.83,0.29,1.13,0.61C7.74,3.59,8.52,3.47,9.1,3.8
C9.91,4.27,9.82,5.27,9.34,5.47z"
        />
      </svg>,
    ],
  ],
  rollPhotographs: [
    <svg x="0px" y="0px" viewBox="0 0 17 25">
      <path
        className="rollPhotographs0"
        d="M11.5,2.83H6.05V2.07c0.86-0.02,1.81-0.04,2.82-0.04c0.94,0,1.81,0.02,2.62,0.04C11.5,2.32,11.5,2.58,11.5,2.83
z"
      />
      <path
        className="rollPhotographs1"
        d="M11.52,2.28H6.05V0.31c0.87-0.06,1.82-0.1,2.83-0.1c0.94,0,1.82,0.04,2.63,0.1
C11.52,0.97,11.52,1.62,11.52,2.28z"
      />
      <path
        className="rollPhotographs2"
        d="M3.41,21.82C2.27,21.76,1.13,21.7,0,21.63c0-5.36,0-10.72,0-16.08c1.1-0.07,2.2-0.14,3.31-0.21
C3.34,10.83,3.38,16.33,3.41,21.82z"
      />
      <path
        className="rollPhotographs3"
        d="M16.48,17.87c-4.38,1.47-8.75,2.94-13.13,4.4V4.46c2.01-0.09,4.29-0.09,6.78,0.1c2.43,0.19,4.63,0.52,6.56,0.91
c-0.17,2.36-0.27,4.85-0.29,7.47C16.4,14.64,16.43,16.29,16.48,17.87z"
      />
      <path
        className="rollPhotographs4"
        d="M16.48,17.72c0.08,1.36,0.16,2.73,0.24,4.09c-4.45,0-8.9-0.01-13.35-0.01c0.01-1.37,0.03-2.74,0.04-4.1
c2.13,0.02,4.26,0.04,6.39,0.05"
      />
      <rect
        x="10.96"
        y="5.48"
        className="rollPhotographs4"
        width="0.19"
        height="16.37"
      />
      <rect
        x="11.27"
        y="5.46"
        className="rollPhotographs4"
        width="0.19"
        height="16.37"
      />
      <rect
        x="11.57"
        y="5.47"
        className="rollPhotographs4"
        width="0.19"
        height="16.37"
      />
      <rect
        x="11.92"
        y="5.48"
        className="rollPhotographs4"
        width="0.19"
        height="16.37"
      />
      <rect
        x="4.71"
        y="5.2"
        className="rollPhotographs4"
        width="0.19"
        height="16.37"
      />
      <path
        className="rollPhotographs5"
        d="M16.7,5.48c-2.54,0.04-5.14,0.06-7.81,0.06c-2.67,0-5.29-0.02-7.83-0.06c0-0.34,0-0.68,0-1.02
C3.58,4.5,6.18,4.52,8.85,4.52c2.69,0,5.3-0.02,7.85-0.06C16.7,4.8,16.7,5.14,16.7,5.48z"
      />
      <path
        className="rollPhotographs0"
        d="M16.91,4.48c-2.62,0.06-5.29,0.09-8.01,0.09c-2.7,0-5.36-0.03-7.96-0.09C0.9,4.26,0.87,3.98,0.87,3.67
c0-0.35,0.04-0.65,0.08-0.88c2.56-0.11,5.22-0.17,7.98-0.17s5.42,0.06,7.98,0.17c0.04,0.22,0.08,0.48,0.08,0.78
C17,3.94,16.96,4.25,16.91,4.48z"
      />
      <path
        className="rollPhotographs5"
        d="M16.72,22.75c-2.56,0.04-5.18,0.06-7.86,0.06c-2.69,0-5.32-0.02-7.88-0.06c0-0.36,0-0.71,0-1.07
c2.59,0.05,5.23,0.07,7.9,0.07c2.65,0,5.27-0.03,7.84-0.07C16.72,22.04,16.72,22.4,16.72,22.75z"
      />
      <path
        className="rollPhotographs0"
        d="M16.83,24.58c-2.46,0.13-5.05,0.21-7.74,0.21c-2.87,0-5.62-0.07-8.22-0.21c-0.04-0.27-0.08-0.59-0.08-0.95
c0-0.41,0.04-0.76,0.08-1.02c2.53,0.13,5.19,0.2,7.96,0.21c2.79,0,5.46-0.07,8.01-0.21c0.04,0.26,0.08,0.56,0.08,0.91
C16.91,23.94,16.87,24.31,16.83,24.58z"
      />
      <path
        className="rollPhotographs6"
        d="M3.4,21.75c-0.44-0.08-0.88-0.16-1.33-0.23V5.76C2.51,5.67,2.94,5.59,3.38,5.5C3.38,10.92,3.39,16.33,3.4,21.75
z"
      />
      <text
        transform="matrix(-0.0171 0.9882 -0.9999 -0.0173 7.7676 5.7708)"
        className="rollPhotographs7 rollPhotographs8 rollPhotographs9"
      >
        Cantidad
      </text>
      <text
        transform="matrix(-0.0171 0.9882 -0.9999 -0.0173 7.319 15.6171)"
        className="rollPhotographs7 rollPhotographs8 rollPhotographs10"
      >
        0
      </text>
      <rect
        x="3.3"
        y="5.54"
        className="rollPhotographs11"
        width="1.45"
        height="12.16"
      />
      <path
        className="rollPhotographs12"
        d="M15.89,19.61c0.02,0.7,0.05,1.39,0.08,2.08H3.41c0.01-0.7,0.03-1.39,0.04-2.09c2.03,0.01,4.05,0.02,6.08,0.03"
      />
      <text
        transform="matrix(-0.0171 0.9882 -0.9999 -0.0173 13.2088 5.7518)"
        className="rollPhotographs13 rollPhotographs8 rollPhotographs10"
      >
        Fotografias
      </text>
      <rect
        x="-3.45"
        y="5.43"
        className="rollPhotographs7"
        width="1.98"
        height="3.86"
      />
    </svg>,
  ],
  fishingLine: [
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 5 5">
      <path
        className="fishingLine0"
        d="M3.02,3.56c0.27,0.4,0.3,0.87,0.61,1.04C3.89,4.74,4.3,4.67,4.5,4.41c0.12-0.15,0.17-0.36,0.12-0.54
C4.51,3.43,3.8,3.26,3.8,3.26c0,0,0.24,0.08,0.47,0.31c0.11,0.11,0.18,0.18,0.21,0.29c0.06,0.22-0.04,0.5-0.25,0.64
C4.07,4.61,3.83,4.63,3.65,4.54C3.32,4.38,3.42,4.03,3.05,3.51c-0.29-0.4-0.71-0.68-0.76-0.63c-0.02,0.01-0.02,0.08,0,0.1
C2.31,3,2.33,2.99,2.34,2.99c0.04,0,0.07-0.05,0.07-0.05c0,0-0.04,0.06-0.07,0.05c-0.02,0-0.03-0.03-0.03-0.03
C2.3,2.94,2.3,2.91,2.31,2.9c0.04-0.03,0.23,0.11,0.36,0.23c0.01,0.01,0.05,0.04,0.1,0.1C2.77,3.23,2.91,3.39,3.02,3.56z"
      />
      <path
        className="fishingLine1"
        d="M2.35,2.95C1.43,2.96,1.13,2.83,1.08,2.67C1,2.4,1.7,2.05,1.6,1.75C1.52,1.51,1.04,1.6,0.83,1.31
C0.62,1.03,0.79,0.55,1,0.14"
      />
    </svg>,
  ],
  dumpster: [
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 10 10">
      <g>
        <ellipse className="dumpster0" cx="4.9" cy="9.04" rx="2.79" ry="0.8" />
        <path
          className="dumpster0"
          d="M8.96,2.06C8.53,4.43,8.11,6.81,7.69,9.18L2.1,9.15C1.74,6.78,1.39,4.42,1.03,2.06H8.96z"
        />
      </g>
      <ellipse className="dumpster1" cx="4.99" cy="2.06" rx="3.95" ry="1.06" />
      <ellipse className="dumpster2" cx="4.99" cy="2.04" rx="3.92" ry="1.01" />
    </svg>,
  ],
  iconGallery: [
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 30 30">
      <path
        className="iconGallery0"
        d="M28.85,22.61c-3.77,0.51-8.23,0.88-13.25,0.84c-4.49-0.03-8.52-0.38-11.99-0.84c0-5.68,0-11.37,0-17.05
c3.73-0.4,7.97-0.68,12.62-0.68s8.89,0.27,12.62,0.68C28.85,11.25,28.85,16.93,28.85,22.61z"
      />
      <circle className="iconGallery1" cx="10.28" cy="12.57" r="1.32" />
      <path
        className="iconGallery1"
        d="M23.96,8.18c-2.22-0.31-4.73-0.52-7.5-0.52c-2.79,0-5.32,0.21-7.55,0.52c0-0.79,0-1.57,0-2.36
c2.13-0.26,4.48-0.44,7.03-0.46c2.93-0.02,5.62,0.17,8.01,0.46C23.96,6.61,23.96,7.4,23.96,8.18z"
      />
      <rect
        x="-8.69"
        y="3.18"
        className="iconGallery2"
        width="0.5"
        height="0.05"
      />
      <ellipse
        className="iconGallery3"
        cx="10.29"
        cy="12.57"
        rx="0.88"
        ry="0.89"
      />
      <ellipse
        className="iconGallery1"
        cx="16.55"
        cy="16.71"
        rx="5.4"
        ry="5.35"
      />
      <rect
        x="15.72"
        y="11.91"
        transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 33.3292 0.168)"
        className="iconGallery0"
        width="1.72"
        height="9.68"
      />
      <path
        className="iconGallery4"
        d="M19.77,16.62c0,1.76-1.43,3.19-3.19,3.19s-3.19-1.43-3.19-3.19c0-1.76,1.43-3.19,3.19-3.19
S19.77,14.86,19.77,16.62z"
      />
      <ellipse
        className="iconGallery5"
        cx="16.57"
        cy="16.75"
        rx="4.92"
        ry="4.84"
      />
      <ellipse
        className="iconGallery0"
        cx="16.57"
        cy="16.63"
        rx="2.83"
        ry="2.85"
      />
      <ellipse
        className="iconGallery6"
        cx="16.57"
        cy="16.64"
        rx="2.54"
        ry="2.56"
      />
      <path
        className="iconGallery1"
        d="M8.81,21.84c-0.47-0.01-0.97-0.03-1.48-0.06c-0.88-0.06-1.7-0.14-2.45-0.25c0-0.69,0-1.38,0-2.07
c0.58,0.07,1.2,0.13,1.86,0.17c0.77,0.05,1.49,0.06,2.15,0.06C8.86,20.41,8.84,21.12,8.81,21.84z"
      />
    </svg>,
  ],
  iconApi: [
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 30 30">
      <path
        className="iconApi0"
        d="M11.4,23.03c-1.4-1.29-2.79-2.58-4.19-3.87c0.91-1.08,1.81-2.16,2.72-3.23l4.55,4.26
C13.45,21.13,12.43,22.08,11.4,23.03z"
      />
      <path
        className="iconApi0"
        d="M15.13,20.16l-5.16-4.83c0.15-0.2,0.33-0.43,0.56-0.67c0.18-0.19,0.36-0.35,0.52-0.48
c1.72,1.61,3.44,3.22,5.16,4.83c-0.13,0.18-0.29,0.38-0.49,0.6C15.51,19.83,15.3,20.01,15.13,20.16z"
      />
      <path
        className="iconApi0"
        d="M10.93,22.56c-1.08-0.99-2.16-1.98-3.23-2.97c0.83-0.98,1.65-1.96,2.48-2.94c1.18,1.11,2.36,2.21,3.55,3.32
C12.79,20.84,11.86,21.7,10.93,22.56z"
      />
      <ellipse
        transform="matrix(0.6834 -0.7301 0.7301 0.6834 -10.9852 14.0291)"
        className="iconApi0"
        cx="10.68"
        cy="19.68"
        rx="1.67"
        ry="1.69"
      />
      <path
        className="iconApi1"
        d="M11.18,23.34c-0.72-0.6-1.45-1.26-2.2-1.96c-0.73-0.69-1.41-1.36-2.05-2.02c0.09-0.09,0.17-0.18,0.26-0.27
l4.25,3.98L11.18,23.34z"
      />
      <path
        className="iconApi0"
        d="M9.82,22.97c-0.4-0.27-0.86-0.62-1.32-1.06c-0.44-0.42-0.81-0.83-1.09-1.2c0.13-0.14,0.27-0.29,0.4-0.43
l2.42,2.26L9.82,22.97z"
      />
      <path
        className="iconApi0"
        d="M8.59,23.79c-0.32-0.17-0.74-0.44-1.15-0.84c-0.36-0.35-0.62-0.7-0.8-0.99c0.32-0.34,0.63-0.68,0.95-1.01
c0.25,0.31,0.56,0.66,0.94,1.01c0.36,0.33,0.71,0.6,1.02,0.82C9.23,23.11,8.91,23.45,8.59,23.79z"
      />
      <path
        className="iconApi0"
        d="M8,23.41c-0.16-0.1-0.34-0.23-0.52-0.41c-0.17-0.16-0.3-0.32-0.4-0.46c0.33-0.35,0.66-0.7,0.99-1.06
c0.13,0.14,0.27,0.28,0.42,0.43c0.17,0.16,0.34,0.31,0.5,0.44C8.66,22.71,8.33,23.06,8,23.41z"
      />
      <path
        className="iconApi0"
        d="M14.93,20.03l-4.87-4.56c-0.04,0.03-0.09,0.06-0.14,0.12c-0.06,0.06-0.1,0.12-0.13,0.17
c1.62,1.52,3.25,3.04,4.87,4.56c0.04-0.03,0.1-0.07,0.16-0.13C14.87,20.13,14.91,20.07,14.93,20.03z"
      />
      <path
        className="iconApi0"
        d="M12.33,15.36l-0.45-0.42l2.09-2.23c0.07,0.04,0.16,0.09,0.26,0.19c0.09,0.09,0.15,0.17,0.19,0.24
C13.73,13.87,13.03,14.62,12.33,15.36z"
      />
      <path
        className="iconApi2"
        d="M3.91,27.11c-0.04-0.32-0.08-0.64-0.12-0.96c1.43-0.27,1.95-0.78,2.16-1.22c0.19-0.42,0.15-0.9,0.55-1.58
c0.2-0.34,0.43-0.58,0.58-0.74c0.12,0.13,0.25,0.26,0.39,0.4c0.12,0.12,0.24,0.22,0.36,0.32c-0.12,0.12-0.28,0.32-0.45,0.57
c-0.52,0.79-0.54,1.42-0.72,1.83C6.44,26.25,5.8,26.84,3.91,27.11z"
      />
      <path
        className="iconApi0"
        d="M19.35,6.97c1.38,1.33,2.75,2.66,4.13,3.98c-0.93,1.06-1.87,2.13-2.8,3.19L16.2,9.77
C17.25,8.84,18.3,7.91,19.35,6.97z"
      />
      <path
        className="iconApi0"
        d="M15.54,9.78l5.08,4.96c-0.15,0.2-0.34,0.42-0.58,0.66c-0.19,0.19-0.37,0.34-0.53,0.47
c-1.69-1.65-3.39-3.31-5.08-4.96c0.13-0.17,0.3-0.38,0.51-0.59C15.16,10.1,15.36,9.92,15.54,9.78z"
      />
      <path
        className="iconApi0"
        d="M19.82,7.46c1.06,1.02,2.13,2.04,3.19,3.05c-0.85,0.97-1.71,1.93-2.56,2.9c-1.16-1.14-2.33-2.28-3.49-3.41
C17.91,9.15,18.86,8.3,19.82,7.46z"
      />
      <ellipse
        transform="matrix(0.6987 -0.7154 0.7154 0.6987 -1.3831 17.4322)"
        className="iconApi0"
        cx="20"
        cy="10.36"
        rx="1.68"
        ry="1.7"
      />
      <path
        className="iconApi1"
        d="M19.58,6.67c0.71,0.62,1.44,1.29,2.17,2.02c0.72,0.7,1.39,1.4,2.02,2.08c-0.09,0.09-0.18,0.18-0.26,0.27
l-4.19-4.09L19.58,6.67z"
      />
      <path
        className="iconApi0"
        d="M20.94,7.07c0.4,0.28,0.85,0.64,1.31,1.1c0.44,0.43,0.79,0.85,1.07,1.23c-0.14,0.14-0.28,0.28-0.41,0.42
l-2.38-2.33L20.94,7.07z"
      />
      <path
        className="iconApi0"
        d="M22.19,6.27c0.32,0.18,0.73,0.46,1.14,0.87c0.36,0.36,0.61,0.72,0.79,1.01c-0.33,0.33-0.65,0.67-0.98,1
c-0.24-0.32-0.54-0.68-0.92-1.04c-0.35-0.34-0.7-0.62-1.01-0.84C21.54,6.94,21.87,6.6,22.19,6.27z"
      />
      <path
        className="iconApi0"
        d="M22.78,6.66c0.15,0.1,0.33,0.24,0.52,0.42c0.17,0.17,0.3,0.33,0.4,0.47c-0.34,0.35-0.68,0.69-1.02,1.04
c-0.13-0.14-0.26-0.29-0.42-0.44c-0.17-0.17-0.34-0.32-0.5-0.45C22.1,7.36,22.44,7.01,22.78,6.66z"
      />
      <path
        className="iconApi0"
        d="M15.74,9.92l4.8,4.68c0.04-0.03,0.09-0.06,0.15-0.11c0.06-0.06,0.1-0.12,0.13-0.17c-1.6-1.56-3.2-3.12-4.8-4.68
c-0.05,0.03-0.1,0.07-0.16,0.13C15.8,9.82,15.76,9.87,15.74,9.92z"
      />
      <path
        className="iconApi2"
        d="M25.53,1.97c0.3,0.09,0.61,0.18,0.91,0.27c-0.35,1.3-0.96,2.88-2.1,4.42c-0.22,0.3-0.45,0.58-0.68,0.84
c-0.11-0.13-0.22-0.27-0.36-0.41c-0.12-0.13-0.25-0.25-0.36-0.35c0.16-0.19,0.37-0.45,0.6-0.78c0.11-0.15,0.51-0.73,0.99-1.65
C24.83,3.72,25.19,2.94,25.53,1.97z"
      />
      <path
        className="iconApi0"
        d="M13.83,16.75l-0.45-0.42l2.1-2.25c0.07,0.03,0.16,0.09,0.26,0.19c0.09,0.09,0.15,0.17,0.19,0.24
C15.23,15.25,14.53,16,13.83,16.75z"
      />
      <path
        className="iconApi0"
        d="M15.36,18.21l-0.45-0.42l2.1-2.24c0.07,0.04,0.16,0.09,0.26,0.19c0.09,0.09,0.15,0.17,0.19,0.24
C16.76,16.72,16.06,17.46,15.36,18.21z"
      />
    </svg>,
  ],
  iconGitLab: [
    <svg width={'2.1rem'} height={'2.1rem'} style={{margin:'0 0.3rem 0 0'}} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <polygon
        points="16 28.896 16 28.896 21.156 13.029 10.844 13.029 16 28.896"
        style={{ fill: '#e24329' }}
      />
      <polygon
        points="16 28.896 10.844 13.029 3.619 13.029 16 28.896"
        style={{ fill: '#fc6d26' }}
      />
      <path
        d="M3.619,13.029h0L2.052,17.851a1.067,1.067,0,0,0,.388,1.193L16,28.9,3.619,13.029Z"
        style={{ fill: '#fca326' }}
      />
      <path
        d="M3.619,13.029h7.225L7.739,3.473a.534.534,0,0,0-1.015,0L3.619,13.029Z"
        style={{ fill: '#e24329' }}
      />
      <polygon
        points="16 28.896 21.156 13.029 28.381 13.029 16 28.896"
        style={{fill:'#fc6d26'}}
      />
      <path
        d="M28.381,13.029h0l1.567,4.822a1.067,1.067,0,0,1-.388,1.193L16,28.9,28.381,13.029Z"
        style={{ fill: '#fca326' }}
      />
      <path
        d="M28.381,13.029H21.156l3.105-9.557a.534.534,0,0,1,1.015,0l3.105,9.557Z"
        style={{ fill: '#e24329' }}
      />
    </svg>,
  ],
});

export default svg;
